import { DynamicObject } from 'src/utils/commonTypes';
import { SPORTS_ROUTE } from 'src/utils/constants/ApiConstants';
import { ASSET_TYPE, GUEST_TOKEN } from 'src/utils/constants/AppConstants';
import { META_EVENTS } from 'src/utils/constants/metaPixelConstants';
import { CHANNEL_GUIDE_CONSTANTS } from 'src/utils/constants/utilConstants';

import { mixpanelObject } from './mixpanel';
import {
  MIXPANEL_ACTIVE_PARTNER_SUBSCRIPTION,
  MIXPANEL_ACTUAL_COST,
  MIXPANEL_AD_CAMPAIGN_ID,
  MIXPANEL_AD_CREATIVE_ID,
  MIXPANEL_AD_ID,
  MIXPANEL_AD_ISEMPTY,
  MIXPANEL_AD_LOCATION,
  MIXPANEL_AD_SIZE,
  MIXPANEL_AGE,
  MIXPANEL_AGGREGATOR_PARTNER_ID,
  MIXPANEL_AGGREGATOR_PARTNER_NAME,
  MIXPANEL_AGGREGATOR_USER_TYPE,
  MIXPANEL_AUDIO_LANGUAGE,
  MIXPANEL_AVOD_OR_SVOD_CONTENT,
  MIXPANEL_BANK_NAME,
  MIXPANEL_BILLING_COUNTRY,
  MIXPANEL_BILLING_STATE,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_CARD_NAME,
  MIXPANEL_CARD_RANK,
  MIXPANEL_CARD_TYPE,
  MIXPANEL_CAROUSAL_ID,
  MIXPANEL_CAROUSAL_NAME,
  MIXPANEL_CAROUSAL_SLOT_ID,
  MIXPANEL_CHANNEL_NAME,
  MIXPANEL_CHARACTERS,
  MIXPANEL_CITY,
  MIXPANEL_COHORT_DISCOUNT_PERCENT,
  MIXPANEL_COHORT_ID,
  MIXPANEL_CONTENT_BILLING_TYPE,
  MIXPANEL_CONTENT_COUNT,
  MIXPANEL_CONTENT_DURATION,
  MIXPANEL_CONTENT_ID,
  MIXPANEL_CONTENT_NAME,
  MIXPANEL_CONTENT_ORIGIAL_LANGUAGE,
  MIXPANEL_CONTENT_OWNER,
  MIXPANEL_CONTENT_SPECIFICATION,
  MIXPANEL_CONTENT_TYPE,
  MIXPANEL_COST,
  MIXPANEL_COUNTER,
  MIXPANEL_COUPON_CODE,
  MIXPANEL_CROSS_COMMERCE,
  MIXPANEL_CTA,
  MIXPANEL_CTAS,
  MIXPANEL_CURRENT_SUBSCRIPTION,
  MIXPANEL_DAYS_TO_EXPIRY,
  MIXPANEL_DEEPLINK_PARTNER_NAME,
  MIXPANEL_DEEPLINK_REDIRECTION_PATH,
  MIXPANEL_DEKEY,
  MIXPANEL_DIRECTION,
  MIXPANEL_ELEMENT,
  MIXPANEL_EPISODE_NO,
  MIXPANEL_EVENTS_ADD_TO_WATCHLIST,
  MIXPANEL_EVENTS_AD_BANNER_IMPRESSION,
  MIXPANEL_EVENTS_BELLY_UNIT_CTA,
  MIXPANEL_EVENTS_CARD_IMPRESSION,
  MIXPANEL_EVENTS_CLEAR_SEARCH_HISTORY,
  MIXPANEL_EVENTS_CONTENT_BANNER_CLICK,
  MIXPANEL_EVENTS_CONTENT_LANGUAGE_CHANGE,
  MIXPANEL_EVENTS_CTAS,
  MIXPANEL_EVENTS_DEEP_LINK_DATA,
  MIXPANEL_EVENTS_DEEP_LINK_REDIRECTION,
  MIXPANEL_EVENTS_DEFAULT_SETTING_RESTORED,
  MIXPANEL_EVENTS_DISPLAY_LANGUAGE_CHANGE,
  MIXPANEL_EVENTS_EDURACTAS,
  MIXPANEL_EVENTS_EPISODE_LIST_CHOSEN,
  MIXPANEL_EVENTS_INTERIM_SUBSCRIPTION_PAYMENT_SUCCESS,
  MIXPANEL_EVENTS_LOGIN_INITIATED,
  MIXPANEL_EVENTS_LOGIN_RESULT,
  MIXPANEL_EVENTS_LOGIN_SCREEN_DISPLAY,
  MIXPANEL_EVENTS_LOGOUT,
  MIXPANEL_EVENTS_PACK_TOGGLE,
  MIXPANEL_EVENTS_PAGE_RAIL_IMPRESSION,
  MIXPANEL_EVENTS_PARENTAL_OVERLAY_IMPRESSION,
  MIXPANEL_EVENTS_PARENTAL_OVERLAY_RESULT,
  MIXPANEL_EVENTS_PARTNER_SETTING_DATA,
  MIXPANEL_EVENTS_PLAYER_CTAS,
  MIXPANEL_EVENTS_POPUP_LAUNCH,
  MIXPANEL_EVENTS_POP_UP_CTAS,
  MIXPANEL_EVENTS_PREPAID_CODE_RESULT,
  MIXPANEL_EVENTS_PROMO_CODE_RESULT,
  MIXPANEL_EVENTS_RECOMMENDED_RAIL_IMPRESSION,
  MIXPANEL_EVENTS_REMOVE_FROM_WATCHLIST,
  MIXPANEL_EVENTS_RIBBON_CTA_EVENT,
  MIXPANEL_EVENTS_RIBBON_IMPRESSION,
  MIXPANEL_EVENTS_SCREEN_VIEW,
  MIXPANEL_EVENTS_SEARCH_BUTTON_CLICK,
  MIXPANEL_EVENTS_SEARCH_CANCELLED_EVENT,
  MIXPANEL_EVENTS_SEARCH_CLEARED,
  MIXPANEL_EVENTS_SEARCH_RAIL_IMPRESSION,
  MIXPANEL_EVENTS_SEARCH_RESULT_CLICKED,
  MIXPANEL_EVENTS_SEARCH_STARTED,
  MIXPANEL_EVENTS_SEARCH_THUMBNAIL_CLICK,
  MIXPANEL_EVENTS_SESSION,
  MIXPANEL_EVENTS_SETTING_CHANGED,
  MIXPANEL_EVENTS_SHARE,
  MIXPANEL_EVENTS_SKIP_LOGIN,
  MIXPANEL_EVENTS_SKIP_REGISTRATION,
  MIXPANEL_EVENTS_SUBSCRIPTION_CALL_INITIATED,
  MIXPANEL_EVENTS_SUBSCRIPTION_PAGE_VIEWED,
  MIXPANEL_EVENTS_SUBSCRIPTION_PLAN_VIEWED,
  MIXPANEL_EVENTS_SUBSCRIPTION_SELECTED,
  MIXPANEL_EVENTS_THUMBNAIL_CLICK,
  MIXPANEL_EVENTS_TOAST_MESSAGE_IMPRESSION,
  MIXPANEL_EVENTS_VIEW_MORE_SELECTED,
  MIXPANEL_EVENTS_VOICE_ERROR_DISPLAYED,
  MIXPANEL_EVENTS_WIDGET_CTA_EVENT,
  MIXPANEL_EVENTS_WIDGET_IMPRESSION_EVENT,
  MIXPANEL_EXPERIMENT_NAME,
  MIXPANEL_EXPLORE_LOOKS,
  MIXPANEL_EXTERNAL_LINK,
  MIXPANEL_FAILURE_REASON,
  MIXPANEL_FREE_TRIAL_EXPIRY_DATE,
  MIXPANEL_FREE_TRIAL_PACKAGE,
  MIXPANEL_GENDER,
  MIXPANEL_GENRE,
  MIXPANEL_HAS_EDUAURAA,
  MIXPANEL_HAS_RENTAL,
  MIXPANEL_HORIZONTAL_INDEX,
  MIXPANEL_IMAGE_URL,
  MIXPANEL_ISB2B,
  MIXPANEL_IS_EDUAURAA,
  MIXPANEL_IS_EMAIL_PRESENT,
  MIXPANEL_IS_LIVE,
  MIXPANEL_IS_MOBILE_PRESENT,
  MIXPANEL_IS_PREMIUM_CONTENT,
  MIXPANEL_IS_PWA,
  MIXPANEL_IS_RECOMMENDED,
  MIXPANEL_IS_RENTAL,
  MIXPANEL_IS_SUBSCRIPTION_FLOW,
  MIXPANEL_IS_TALAMOOS,
  MIXPANEL_IS_UPGRADE,
  MIXPANEL_LANDING_PAGE_NAME,
  MIXPANEL_LATEST_SUBSCRIPTION_PACK,
  MIXPANEL_LATEST_SUBSCRIPTION_PACK_EXPIRY,
  MIXPANEL_LIKE_DISLIKE_TOGGLE,
  MIXPANEL_LOAD_TIME,
  MIXPANEL_METHOD,
  MIXPANEL_MINUTES_TO_EXPIRY,
  MIXPANEL_MODEL_ID,
  MIXPANEL_MODEL_NAME,
  MIXPANEL_MODEL_ORIGIN,
  MIXPANEL_NAVIGATION_PROPERTY,
  MIXPANEL_NEW_APP_LANGUAGE,
  MIXPANEL_NEW_AUTOPLAY_SETTING,
  MIXPANEL_NEW_CONTENT_LANGUAGE,
  MIXPANEL_NEXT_EXPIRING_PACK,
  MIXPANEL_NEXT_PACK_EXPIRY_DATE,
  MIXPANEL_NOT_AVAILABLE,
  MIXPANEL_NO_KEYWORD,
  MIXPANEL_NO_MODEL_SERVED,
  MIXPANEL_NULL_SEARCH,
  MIXPANEL_OLD_APP_LANGUAGE,
  MIXPANEL_OLD_CONTENT_LANGUAGE,
  MIXPANEL_PACK_DURATION,
  MIXPANEL_PACK_SELECTED,
  MIXPANEL_PAGE_NAME,
  MIXPANEL_PARENT_CONTROL_SETTING,
  MIXPANEL_PARTNER_ID,
  MIXPANEL_PARTNER_NAME,
  MIXPANEL_PAYMENT_GATEWAY,
  MIXPANEL_PAYMENT_JOURNEY,
  MIXPANEL_PAYMENT_METHOD,
  MIXPANEL_PLATFORM_NAME,
  MIXPANEL_PLATFORM_SECTION,
  MIXPANEL_POP_UP_GROUP,
  MIXPANEL_POP_UP_NAME,
  MIXPANEL_POP_UP_TYPE,
  MIXPANEL_PREPAID_CODE,
  MIXPANEL_PREVIEW_STATUS,
  MIXPANEL_PROMO_CODE,
  MIXPANEL_PROMO_CODE_TYPE,
  MIXPANEL_PS_PARTNER_NAME,
  MIXPANEL_PUBLISHING_DATE,
  MIXPANEL_PWA_APP_VERSION,
  MIXPANEL_QUERY_ID,
  MIXPANEL_QWIKCILVER,
  MIXPANEL_RAIL_CONTENT_LISTING,
  MIXPANEL_RAIL_CONTENT_LISTING_ID,
  MIXPANEL_RECENT_SEARCH_QUERY_DISPLAYED,
  MIXPANEL_REGION,
  MIXPANEL_REGISTRING_COUNTRY,
  MIXPANEL_RENTAL_EXPIRY_DATE,
  MIXPANEL_RENTAL_PURCHASE_DATE,
  MIXPANEL_RENTAL_PURCHASE_EXPIRY_DATE,
  MIXPANEL_RENTAL_RELEASE_DATE,
  MIXPANEL_RESULTS_RETURNED,
  MIXPANEL_SEARCH_LANDING,
  MIXPANEL_SEARCH_QUERY,
  MIXPANEL_SEARCH_TYPE,
  MIXPANEL_SELECTION_SOURCE,
  MIXPANEL_SELECT_BY,
  MIXPANEL_SERIES,
  MIXPANEL_SESSION_ID,
  MIXPANEL_SHARING_PLATFORM,
  MIXPANEL_SOCIAL_AUTHORIZATION,
  MIXPANEL_SOCIAL_NETWORK,
  MIXPANEL_SOURCE,
  MIXPANEL_STATE,
  MIXPANEL_SUBSCRIPTION_CTA_CLICK,
  MIXPANEL_SUBSCRIPTION_PACK_TOGGLE,
  MIXPANEL_SUBSCRIPTION_STATUS,
  MIXPANEL_SUBTITLES,
  MIXPANEL_SUBTITLE_LANGUAGE,
  MIXPANEL_SUCCESS,
  MIXPANEL_TAB_NAME,
  MIXPANEL_TALAMOOS_CLICKID,
  MIXPANEL_TALAMOOS_MODELNAME,
  MIXPANEL_TALAMOOS_ORIGIN,
  MIXPANEL_TALAMOOS_VERTICAL_INDEX,
  MIXPANEL_TOAST_MESSAGE,
  MIXPANEL_TOP_CATEGORY,
  MIXPANEL_TRANSACTION_CURRENCY,
  MIXPANEL_TVOD,
  MIXPANEL_TYPE,
  MIXPANEL_UNIQUE_ID,
  MIXPANEL_USER_TYPE,
  MIXPANEL_VARIANT_NAME,
  MIXPANEL_VERTICAL_INDEX,
  MIXPANEL_VIDEO_AUTOPLAYED,
  MIXPANEL_VOICE_ERROR_MESSAGE,
  MIXPANEL_WIDGET_NAME,
  MIXPANEL_ZEE5_COUNTRY,
  MIXPANEL_NAME,
  MIXPANEL_MOBILE,
  MIXPANEL_PHONE,
  MIXPANEL_EMAIL,
  MIXPANEL_IP
} from './mixpanelConstants';
import {
  getUserTypeForGlobal,
  partnerNameSetter,
  removeProperties
} from './mixpanelHelper';
import {
  getCookie,
  getExperimentName,
  getExperimentVariant,
  getLocalStorage,
  getSessionStorage
} from '../../browserStorageHandler';
import { campaignParams } from '../../common';
import { PAGE_NAME_CONSTANTS } from '../../constants/ConsumptionPagesConstants';
import { COUNTRY } from '../../constants/cookieConstants';
import {
  GLOBAL_REGION,
  USER_CONSENTS,
  USER_ID,
  USER_TYPE
} from '../../constants/localStorageConstants';
import {
  H1_TAG_TITLE,
  ILT20_CONSUMPTION_PAGE,
  ILT20_TOP_CATEGORY_NAME,
  LEARNING_MENU_TYPE,
  UserTypes
} from '../../constants/stringConstants';
import { clevertapEventPush, clevertapObj } from '../clevertap/clevertapHelper';
import { putFacebookEvent } from '../fbpixel/fbCapiHelper';
import { gtm } from '../gtm';
import { trackEvent } from '../newrelic/RUMHelper';

let utmFlag = true;

// registers the user with his super properties
export const registerSuperProperty = () => {
  if (typeof window !== 'undefined' && window.mixpanel) {
    let trackObject: { [key: string]: unknown } = {};
    if (utmFlag) {
      campaignParams();
      utmFlag = false;
    }
    partnerNameSetter(mixpanelObject);
    trackObject[MIXPANEL_UNIQUE_ID] =
      mixpanelObject.getProperty(MIXPANEL_UNIQUE_ID);
    trackObject[MIXPANEL_SESSION_ID] =
      mixpanelObject.getProperty(MIXPANEL_SESSION_ID);
    trackObject[MIXPANEL_USER_TYPE] = getUserTypeForGlobal(
      getLocalStorage(USER_TYPE)
    );
    trackObject[MIXPANEL_NEXT_EXPIRING_PACK] = mixpanelObject.getProperty(
      MIXPANEL_NEXT_EXPIRING_PACK
    );
    trackObject[MIXPANEL_NEXT_PACK_EXPIRY_DATE] = mixpanelObject.getProperty(
      MIXPANEL_NEXT_PACK_EXPIRY_DATE
    );
    trackObject[MIXPANEL_FREE_TRIAL_EXPIRY_DATE] = mixpanelObject.getProperty(
      MIXPANEL_FREE_TRIAL_EXPIRY_DATE
    );
    trackObject[MIXPANEL_PACK_DURATION] = mixpanelObject.getProperty(
      MIXPANEL_PACK_DURATION
    );
    trackObject[MIXPANEL_FREE_TRIAL_PACKAGE] = mixpanelObject.getProperty(
      MIXPANEL_FREE_TRIAL_PACKAGE
    );
    trackObject[MIXPANEL_GENDER] = mixpanelObject.getProperty(MIXPANEL_GENDER);
    trackObject[MIXPANEL_LATEST_SUBSCRIPTION_PACK] = mixpanelObject.getProperty(
      MIXPANEL_LATEST_SUBSCRIPTION_PACK
    );
    trackObject[MIXPANEL_LATEST_SUBSCRIPTION_PACK_EXPIRY] =
      mixpanelObject.getProperty(MIXPANEL_LATEST_SUBSCRIPTION_PACK_EXPIRY);
    trackObject[MIXPANEL_NEW_APP_LANGUAGE] = mixpanelObject.getProperty(
      MIXPANEL_NEW_APP_LANGUAGE
    );
    trackObject[MIXPANEL_NEW_CONTENT_LANGUAGE] = mixpanelObject.getProperty(
      MIXPANEL_NEW_CONTENT_LANGUAGE
    );
    trackObject[MIXPANEL_PARENT_CONTROL_SETTING] = mixpanelObject.getProperty(
      MIXPANEL_PARENT_CONTROL_SETTING
    );
    trackObject[MIXPANEL_AGE] = mixpanelObject.getProperty(MIXPANEL_AGE);
    trackObject[MIXPANEL_PAYMENT_JOURNEY] = mixpanelObject.getProperty(
      MIXPANEL_PAYMENT_JOURNEY
    );

    trackObject[MIXPANEL_PLATFORM_NAME] = mixpanelObject.getProperty(
      MIXPANEL_PLATFORM_NAME
    );
    trackObject[MIXPANEL_IS_PWA] = mixpanelObject.getProperty(MIXPANEL_IS_PWA);
    trackObject[MIXPANEL_DEKEY] = mixpanelObject.getProperty(MIXPANEL_DEKEY);
    trackObject[MIXPANEL_SOCIAL_AUTHORIZATION] = mixpanelObject.getProperty(
      MIXPANEL_SOCIAL_AUTHORIZATION
    );
    trackObject[MIXPANEL_LANDING_PAGE_NAME] = mixpanelObject.getProperty(
      MIXPANEL_LANDING_PAGE_NAME
    );
    trackObject[MIXPANEL_PARTNER_NAME] = mixpanelObject.getProperty(
      MIXPANEL_PARTNER_NAME
    );
    trackObject[MIXPANEL_HAS_EDUAURAA] = mixpanelObject.getProperty(
      MIXPANEL_HAS_EDUAURAA
    );
    trackObject[MIXPANEL_HAS_RENTAL] =
      mixpanelObject.getProperty(MIXPANEL_HAS_RENTAL);
    trackObject[MIXPANEL_IS_EMAIL_PRESENT] =
      mixpanelObject.getProperty(MIXPANEL_IS_EMAIL_PRESENT) || false;
    trackObject[MIXPANEL_IS_MOBILE_PRESENT] =
      mixpanelObject.getProperty(MIXPANEL_IS_MOBILE_PRESENT) || false;
    trackObject[MIXPANEL_ZEE5_COUNTRY] = mixpanelObject.getProperty(
      MIXPANEL_ZEE5_COUNTRY
    );
    trackObject[MIXPANEL_ISB2B] = mixpanelObject.getProperty(MIXPANEL_ISB2B);
    setTrackObjGlobalData(trackObject);
    if (getCookie(COUNTRY) !== 'IN') {
      trackObject[MIXPANEL_REGION] = getLocalStorage(GLOBAL_REGION);
    }

    if (shouldOptOutOfPII()) {
      const trackObjectWithouPII = optingOutOfPII();
      trackObject = { ...trackObject, ...trackObjectWithouPII };
    }
    if (clevertapObj) {
      clevertapObj.superProperties = { ...trackObject };
    }
    window.mixpanel.register(trackObject);
    mixpanelObject.isSuperPropertyRegistered = true;
    mixpanelObject.triggerDefferedEvents();
  }
};
// Gamification Ribbon CTA Event
export const ribbonCTAEvent = (isPremiumContentFlag = false) => {
  const trackObject = basicInitializer(mixpanelObject, true);
  if (mixpanelObject[MIXPANEL_CONTENT_TYPE] === 'tvod') {
    contentPropertiesCompressor(mixpanelObject, trackObject, true, false);
  }
  trackObject[MIXPANEL_PAGE_NAME] = mixpanelObject[MIXPANEL_PAGE_NAME];
  trackObject[MIXPANEL_SOURCE] = mixpanelObject[MIXPANEL_SOURCE];
  trackObject[MIXPANEL_PLATFORM_SECTION] =
    mixpanelObject[MIXPANEL_PLATFORM_SECTION];
  trackObject[MIXPANEL_BUTTON_TYPE] = mixpanelObject[MIXPANEL_BUTTON_TYPE];
  trackObject[MIXPANEL_ELEMENT] = mixpanelObject[MIXPANEL_ELEMENT];
  trackObject[MIXPANEL_TAB_NAME] = mixpanelObject[MIXPANEL_TAB_NAME];
  trackObject[MIXPANEL_IS_RENTAL] = mixpanelObject[MIXPANEL_IS_RENTAL];

  //TODO: aggregatorEventHelper(trackObject);
  aggregatorEventHelper(trackObject);
  if (isPremiumContentFlag) {
    trackObject[MIXPANEL_IS_PREMIUM_CONTENT] =
      mixpanelObject[MIXPANEL_IS_PREMIUM_CONTENT];
  }
  mixpanelObject.trackEvent(MIXPANEL_EVENTS_RIBBON_CTA_EVENT, trackObject);
  clevertapEventPush(MIXPANEL_EVENTS_RIBBON_CTA_EVENT, trackObject);
};

// clears the super property
export const clearSuperProperty = () => {
  if (typeof window !== 'undefined' && window.mixpanel) {
    const trackObject: { [key: string]: unknown } = {};
    trackObject[MIXPANEL_UNIQUE_ID] = '';
    trackObject[MIXPANEL_SESSION_ID] = 'N/A';
    trackObject[MIXPANEL_USER_TYPE] = 'N/A';
    trackObject[MIXPANEL_NEXT_EXPIRING_PACK] = 'N/A';
    trackObject[MIXPANEL_NEXT_PACK_EXPIRY_DATE] = 'N/A';
    trackObject[MIXPANEL_FREE_TRIAL_EXPIRY_DATE] = 'N/A';
    trackObject[MIXPANEL_PACK_DURATION] = 'N/A';
    trackObject[MIXPANEL_FREE_TRIAL_PACKAGE] = 'N/A';
    trackObject[MIXPANEL_GENDER] = 'N/A';
    trackObject[MIXPANEL_LATEST_SUBSCRIPTION_PACK] = 'N/A';
    trackObject[MIXPANEL_LATEST_SUBSCRIPTION_PACK_EXPIRY] = 'N/A';
    trackObject[MIXPANEL_NEW_APP_LANGUAGE] = 'N/A';
    trackObject[MIXPANEL_NEW_CONTENT_LANGUAGE] = 'N/A';
    trackObject[MIXPANEL_PARENT_CONTROL_SETTING] = 'N/A';
    trackObject[MIXPANEL_AGE] = 'N/A';
    trackObject[MIXPANEL_PLATFORM_NAME] = 'Web';
    trackObject[MIXPANEL_IS_PWA] = false;
    trackObject[MIXPANEL_PARTNER_NAME] = 'N/A';
    trackObject[MIXPANEL_ISB2B] = false;
    if (clevertapObj) {
      clevertapObj.superProperties = {};
    }
    window.mixpanel.register(trackObject);
  }
};

// logout event method
export const logoutEvent = () => {
  // if (typeof window !== "undefined" && window.mixpanel) {
  const trackObject = basicInitializer(mixpanelObject, true);
  mixpanelObject.queueMixpanelEvents(MIXPANEL_EVENTS_LOGOUT, trackObject);
  clevertapEventPush(MIXPANEL_EVENTS_LOGOUT, trackObject);
  // GTM - Logout
  gtm.logOutEventGTM();
  // }
};

export const setAlias = (userId: string, guestToken: string) => {
  if (typeof window !== 'undefined' && window.mixpanel) {
    window.mixpanel.alias(userId, guestToken);
  }
};

export const timeEvent = () => {
  if (window.mixpanel) {
    window.mixpanel.time_event(MIXPANEL_EVENTS_SCREEN_VIEW);
  }
};

// mixpanel basic value initializer
export const basicInitializer = (
  mixpanelObject: { [key: string]: any },
  addElement = false
) => {
  const trackObject: { [key: string]: any } = {};
  trackObject[MIXPANEL_SOURCE] = mixpanelObject.getProperty(MIXPANEL_SOURCE);
  trackObject[MIXPANEL_PAGE_NAME] =
    mixpanelObject.getProperty(MIXPANEL_PAGE_NAME);
  trackObject[MIXPANEL_PWA_APP_VERSION] = mixpanelObject.getProperty(
    MIXPANEL_PWA_APP_VERSION
  );
  trackObject[MIXPANEL_PAYMENT_JOURNEY] = mixpanelObject.getProperty(
    MIXPANEL_PAYMENT_JOURNEY
  );
  trackObject[MIXPANEL_UNIQUE_ID] =
    getLocalStorage(GUEST_TOKEN) || getLocalStorage(USER_ID);
  trackObject[MIXPANEL_PAGE_NAME] =
    mixpanelObject.getProperty(MIXPANEL_PAGE_NAME);
  trackObject[MIXPANEL_IS_EMAIL_PRESENT] =
    mixpanelObject.getProperty(MIXPANEL_IS_EMAIL_PRESENT) || false;
  trackObject[MIXPANEL_IS_MOBILE_PRESENT] =
    mixpanelObject.getProperty(MIXPANEL_IS_MOBILE_PRESENT) || false;
  if (addElement) {
    trackObject[MIXPANEL_ELEMENT] =
      mixpanelObject.getProperty(MIXPANEL_ELEMENT);
  }
  return trackObject;
};

// setting up the people property
export const setPeopleProperty = () => {
  if (typeof window !== 'undefined' && window.mixpanel) {
    let trackObject: { [key: string]: any } = {};
    partnerNameSetter(mixpanelObject);
    trackObject[MIXPANEL_UNIQUE_ID] =
      mixpanelObject.getProperty(MIXPANEL_UNIQUE_ID);
    trackObject[MIXPANEL_REGISTRING_COUNTRY] = mixpanelObject.getProperty(
      MIXPANEL_REGISTRING_COUNTRY
    );
    trackObject[MIXPANEL_NEW_AUTOPLAY_SETTING] = mixpanelObject.getProperty(
      MIXPANEL_NEW_AUTOPLAY_SETTING
    );
    trackObject[MIXPANEL_NEW_APP_LANGUAGE] = mixpanelObject.getProperty(
      MIXPANEL_NEW_APP_LANGUAGE
    );
    trackObject[MIXPANEL_NEW_CONTENT_LANGUAGE] = mixpanelObject.getProperty(
      MIXPANEL_NEW_CONTENT_LANGUAGE
    );
    trackObject[MIXPANEL_USER_TYPE] = getUserTypeForGlobal(
      getLocalStorage(USER_TYPE)
    );
    trackObject[MIXPANEL_NEXT_EXPIRING_PACK] = mixpanelObject.getProperty(
      MIXPANEL_NEXT_EXPIRING_PACK
    );
    trackObject[MIXPANEL_NEXT_PACK_EXPIRY_DATE] = mixpanelObject.getProperty(
      MIXPANEL_NEXT_PACK_EXPIRY_DATE
    );
    trackObject[MIXPANEL_FREE_TRIAL_EXPIRY_DATE] = mixpanelObject.getProperty(
      MIXPANEL_FREE_TRIAL_EXPIRY_DATE
    );
    trackObject[MIXPANEL_PACK_DURATION] = mixpanelObject.getProperty(
      MIXPANEL_PACK_DURATION
    );
    trackObject[MIXPANEL_FREE_TRIAL_PACKAGE] = mixpanelObject.getProperty(
      MIXPANEL_FREE_TRIAL_PACKAGE
    );
    trackObject[MIXPANEL_GENDER] = mixpanelObject.getProperty(MIXPANEL_GENDER);
    trackObject[MIXPANEL_LATEST_SUBSCRIPTION_PACK] = mixpanelObject.getProperty(
      MIXPANEL_LATEST_SUBSCRIPTION_PACK
    );
    trackObject[MIXPANEL_LATEST_SUBSCRIPTION_PACK_EXPIRY] =
      mixpanelObject.getProperty(MIXPANEL_LATEST_SUBSCRIPTION_PACK_EXPIRY);
    trackObject[MIXPANEL_PARENT_CONTROL_SETTING] = mixpanelObject.getProperty(
      MIXPANEL_PARENT_CONTROL_SETTING
    );
    trackObject[MIXPANEL_AGE] = mixpanelObject.getProperty(MIXPANEL_AGE);
    trackObject[MIXPANEL_PARTNER_NAME] = mixpanelObject.getProperty(
      MIXPANEL_PARTNER_NAME
    );
    if (mixpanelObject.getProperty(MIXPANEL_USER_TYPE) !== UserTypes.GUEST) {
      window.mixpanel.people.set(trackObject);
    }
    trackObject[MIXPANEL_HAS_EDUAURAA] = mixpanelObject.getProperty(
      MIXPANEL_HAS_EDUAURAA
    );
    trackObject[MIXPANEL_HAS_RENTAL] =
      mixpanelObject.getProperty(MIXPANEL_HAS_RENTAL);
    if (getCookie(COUNTRY) !== 'IN') {
      trackObject[MIXPANEL_REGION] = getLocalStorage(GLOBAL_REGION);
    }

    if (shouldOptOutOfPII()) {
      const analyticsObjectWithoutPI = optingOutOfPII();
      trackObject = { ...trackObject, ...analyticsObjectWithoutPI };
    }

    if (clevertapObj) {
      clevertapObj.peopleProperties = { ...trackObject };
    }
    if (window?.mixpanel) {
      window.mixpanel.identify(mixpanelObject.getProperty(MIXPANEL_UNIQUE_ID));
    }
    mixpanelObject.isPeoplePropertySet = true;

    mixpanelObject.triggerDefferedEvents();
  }
};

/**
 * As per the ticket, we need to share user's PII only when flag is enabled.
 * https://asiatvusa.atlassian.net/browse/CX-15289
 *
 * @returns : boolean based on user consent value.
 */
export function shouldOptOutOfPII() {
  /**
   * Although `getSessionStorage` does JSON.parse internally, but the output was not completely JSON. Could be due to how it was stored initially.
   * To solve for easy access, doing JSON.parse again.
   */
  const userConsents = getSessionStorage(USER_CONSENTS);

  /**
   *  If value of `IsThirdPartyDataSharing` is false, means user does not want to share data
   *  with 3rd party platforms and hence returning true to optOut;
   *  otherwise false
   */
  if (userConsents && userConsents?.IsThirdPartyDataSharing === false) {
    return true;
  }
  return false;
}

export function optingOutOfPII() {
  mixpanelObject.setProperty(MIXPANEL_NAME, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_AGE, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_GENDER, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_MOBILE, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_PHONE, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_EMAIL, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_UNIQUE_ID, 'N/A');
  mixpanelObject.setProperty(MIXPANEL_IP, 'N/A');
  return mixpanelObject;
}

export const cardImpression = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_CARD_NAME] = mixpanelObject[MIXPANEL_CARD_NAME];
  trackObject[MIXPANEL_CARD_RANK] = mixpanelObject[MIXPANEL_CARD_RANK];
  trackObject[MIXPANEL_VERTICAL_INDEX] =
    mixpanelObject[MIXPANEL_VERTICAL_INDEX];
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_CARD_IMPRESSION,
    trackObject
  );
};

export const exploreLooks = () => {
  const trackObject = basicInitializer(mixpanelObject, true);
  trackObject[MIXPANEL_PAGE_NAME] = mixpanelObject[MIXPANEL_PAGE_NAME];
  mixpanelObject.setProperty(MIXPANEL_WIDGET_NAME, MIXPANEL_CROSS_COMMERCE);
  mixpanelObject.setProperty(MIXPANEL_USER_TYPE);
  mixpanelObject.setProperty(MIXPANEL_SOURCE);
  mixpanelObject.setProperty(
    MIXPANEL_TYPE,
    MIXPANEL_EVENTS_WIDGET_IMPRESSION_EVENT
  );
  commerceEvent();
};
export const buttonEvent = (text: string) => {
  const trackObject = basicInitializer(mixpanelObject, true);
  trackObject[MIXPANEL_PAGE_NAME] = mixpanelObject[MIXPANEL_PAGE_NAME];
  mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_EXPLORE_LOOKS;
  mixpanelObject.setProperty(MIXPANEL_WIDGET_NAME, MIXPANEL_CROSS_COMMERCE);
  mixpanelObject.setProperty(MIXPANEL_USER_TYPE);
  mixpanelObject.setProperty(MIXPANEL_SOURCE);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, text);
  mixpanelObject.setProperty(MIXPANEL_TYPE, MIXPANEL_EVENTS_WIDGET_CTA_EVENT);
  commerceEvent();
};
export const commerceCTA = (text: string) => {
  const trackObject = basicInitializer(mixpanelObject, true);
  trackObject[MIXPANEL_PAGE_NAME] = mixpanelObject[MIXPANEL_PAGE_NAME];
  mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_CTA;
  mixpanelObject.setProperty(MIXPANEL_SOURCE);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, text);
  mixpanelObject.setProperty(MIXPANEL_TYPE, MIXPANEL_CTAS);
  commerceEvent();
};
export const commerceToast = (text: string) => {
  const trackObject = basicInitializer(mixpanelObject, true);
  trackObject[MIXPANEL_PAGE_NAME] = mixpanelObject[MIXPANEL_PAGE_NAME];
  mixpanelObject.setProperty(MIXPANEL_SOURCE);
  mixpanelObject.setProperty(MIXPANEL_TOAST_MESSAGE, text);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, MIXPANEL_NOT_AVAILABLE);
  mixpanelObject.setProperty(MIXPANEL_TYPE, MIXPANEL_TOAST_MESSAGE);
  commerceEvent();
};
export const commerceEvent = (isSeries = false, orderSummary = false) => {
  const trackObject: { [key: string]: any } = basicInitializer(
    mixpanelObject,
    true
  );
  trackObject[MIXPANEL_TAB_NAME] =
    mixpanelObject.getProperty(MIXPANEL_TAB_NAME);
  trackObject[MIXPANEL_CAROUSAL_NAME] = mixpanelObject.getProperty(
    MIXPANEL_CAROUSAL_NAME
  );
  trackObject[MIXPANEL_USER_TYPE] = getUserTypeForGlobal(
    getLocalStorage(USER_TYPE)
  );
  const obj = mixpanelObject;
  trackObject[MIXPANEL_SOURCE] = obj[MIXPANEL_PAGE_NAME];
  trackObject[MIXPANEL_WIDGET_NAME] =
    mixpanelObject.getProperty(MIXPANEL_WIDGET_NAME);
  trackObject[MIXPANEL_CAROUSAL_ID] =
    mixpanelObject.getProperty(MIXPANEL_CAROUSAL_ID);
  trackObject[MIXPANEL_BUTTON_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_BUTTON_TYPE);
  trackObject[MIXPANEL_POP_UP_NAME] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_NAME);
  trackObject[MIXPANEL_POP_UP_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_TYPE);
  trackObject[MIXPANEL_IS_SUBSCRIPTION_FLOW] = mixpanelObject.getProperty(
    MIXPANEL_IS_SUBSCRIPTION_FLOW
  );
  trackObject[MIXPANEL_CONTENT_NAME] = mixpanelObject.getProperty(
    MIXPANEL_CONTENT_NAME
  );
  trackObject[MIXPANEL_CONTENT_ID] =
    mixpanelObject.getProperty(MIXPANEL_CONTENT_ID);
  trackObject[MIXPANEL_PAGE_NAME] = orderSummary
    ? PAGE_NAME_CONSTANTS.ORDER_SUMMARY_SCREEN
    : mixpanelObject.getProperty(MIXPANEL_PAGE_NAME);
  trackObject[MIXPANEL_IS_SUBSCRIPTION_FLOW] = mixpanelObject.getProperty(
    MIXPANEL_IS_SUBSCRIPTION_FLOW
  );
  trackObject[MIXPANEL_TOAST_MESSAGE] = mixpanelObject.getProperty(
    MIXPANEL_TOAST_MESSAGE
  );

  if (isSeries) {
    trackObject[MIXPANEL_SERIES] = mixpanelObject.getProperty(MIXPANEL_SERIES);
  }
  const eventNames = mixpanelObject.getProperty(MIXPANEL_TYPE);
  mixpanelObject.trackEvent(eventNames, trackObject);
  clevertapEventPush(eventNames, trackObject);
  trackEvent(eventNames, trackObject);
};

// cta event method
export const ctaEvent = (
  isSeries = false,
  orderSummary = false,
  newRelicEvent = ''
) => {
  // if (typeof window !== "undefined" && window.mixpanel) {
  const trackObject: { [key: string]: any } = basicInitializer(
    mixpanelObject,
    true
  );
  trackObject[MIXPANEL_TAB_NAME] =
    mixpanelObject.getProperty(MIXPANEL_TAB_NAME);
  trackObject[MIXPANEL_CAROUSAL_NAME] = mixpanelObject.getProperty(
    MIXPANEL_CAROUSAL_NAME
  );
  trackObject[MIXPANEL_CAROUSAL_ID] =
    mixpanelObject.getProperty(MIXPANEL_CAROUSAL_ID);
  trackObject[MIXPANEL_BUTTON_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_BUTTON_TYPE);
  trackObject[MIXPANEL_POP_UP_NAME] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_NAME);
  trackObject[MIXPANEL_POP_UP_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_TYPE);
  trackObject[MIXPANEL_IS_SUBSCRIPTION_FLOW] = mixpanelObject.getProperty(
    MIXPANEL_IS_SUBSCRIPTION_FLOW
  );
  trackObject[MIXPANEL_CONTENT_NAME] = mixpanelObject.getProperty(
    MIXPANEL_CONTENT_NAME
  );
  trackObject[MIXPANEL_CONTENT_ID] =
    mixpanelObject.getProperty(MIXPANEL_CONTENT_ID);
  trackObject[MIXPANEL_UNIQUE_ID] =
    mixpanelObject.getProperty(MIXPANEL_UNIQUE_ID);
  trackObject[MIXPANEL_CONTENT_NAME] = mixpanelObject.getProperty(
    MIXPANEL_CONTENT_NAME
  );
  trackObject[MIXPANEL_CONTENT_ID] =
    mixpanelObject.getProperty(MIXPANEL_CONTENT_ID);

  trackObject[MIXPANEL_HORIZONTAL_INDEX] = mixpanelObject.getProperty(
    MIXPANEL_HORIZONTAL_INDEX
  );
  trackObject[MIXPANEL_PAGE_NAME] = orderSummary
    ? PAGE_NAME_CONSTANTS.ORDER_SUMMARY_SCREEN
    : mixpanelObject.getProperty(MIXPANEL_PAGE_NAME);
  trackObject[MIXPANEL_IS_SUBSCRIPTION_FLOW] = mixpanelObject.getProperty(
    MIXPANEL_IS_SUBSCRIPTION_FLOW
  );

  trackObject[MIXPANEL_ELEMENT] = mixpanelObject[MIXPANEL_ELEMENT] || 'N/A';
  if (isSeries) {
    trackObject[MIXPANEL_SERIES] = mixpanelObject.getProperty(MIXPANEL_SERIES);
  }
  const ctas =
    mixpanelObject.getProperty(MIXPANEL_TYPE) === LEARNING_MENU_TYPE
      ? MIXPANEL_EVENTS_EDURACTAS
      : MIXPANEL_EVENTS_CTAS;
  aggregatorEventHelper(trackObject);
  mixpanelObject.trackEvent(ctas, trackObject);
  clevertapEventPush(ctas, trackObject);
  trackEvent(newRelicEvent || ctas, trackObject);
};

// ad banner impression
export const adBannerImpression = () => {
  const trackObject: { [key: string]: any } = basicInitializer(
    mixpanelObject,
    true
  );
  trackObject[MIXPANEL_AD_ID] = mixpanelObject.getProperty(MIXPANEL_AD_ID);
  trackObject[MIXPANEL_AD_CAMPAIGN_ID] = mixpanelObject.getProperty(
    MIXPANEL_AD_CAMPAIGN_ID
  );
  trackObject[MIXPANEL_AD_CREATIVE_ID] = mixpanelObject.getProperty(
    MIXPANEL_AD_CREATIVE_ID
  );
  trackObject[MIXPANEL_AD_SIZE] = mixpanelObject.getProperty(MIXPANEL_AD_SIZE);
  trackObject[MIXPANEL_AD_LOCATION] =
    mixpanelObject.getProperty(MIXPANEL_AD_LOCATION);
  trackObject[MIXPANEL_AD_ISEMPTY] =
    mixpanelObject.getProperty(MIXPANEL_AD_ISEMPTY);
  trackObject[MIXPANEL_VERTICAL_INDEX] = mixpanelObject.getProperty(
    MIXPANEL_VERTICAL_INDEX
  );
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_AD_BANNER_IMPRESSION,
    trackObject
  );
};

// subscription page viewed event method
export const subscriptionPageViewedEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_CAROUSAL_NAME] =
    mixpanelObject[MIXPANEL_CAROUSAL_NAME as keyof typeof mixpanelObject];
  trackObject[MIXPANEL_CAROUSAL_ID] =
    mixpanelObject[MIXPANEL_CAROUSAL_ID as keyof typeof mixpanelObject];
  trackObject[MIXPANEL_POP_UP_NAME] =
    mixpanelObject[MIXPANEL_POP_UP_NAME as keyof typeof mixpanelObject];
  trackObject[MIXPANEL_POP_UP_TYPE] =
    mixpanelObject[MIXPANEL_POP_UP_TYPE as keyof typeof mixpanelObject];
  trackObject[MIXPANEL_POP_UP_GROUP] =
    mixpanelObject[MIXPANEL_POP_UP_GROUP as keyof typeof mixpanelObject];
  trackObject[MIXPANEL_IS_SUBSCRIPTION_FLOW] =
    mixpanelObject[
      MIXPANEL_IS_SUBSCRIPTION_FLOW as keyof typeof mixpanelObject
    ];
  trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
  trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';
  trackObject[MIXPANEL_COHORT_ID] =
    mixpanelObject.getProperty(MIXPANEL_COHORT_ID);
  trackObject[MIXPANEL_COUPON_CODE] =
    mixpanelObject.getProperty(MIXPANEL_COUPON_CODE);
  trackObject[MIXPANEL_PAYMENT_JOURNEY] = mixpanelObject.getProperty(
    MIXPANEL_PAYMENT_JOURNEY
  );
  trackObject[MIXPANEL_SELECTION_SOURCE] = mixpanelObject.getProperty(
    MIXPANEL_SELECTION_SOURCE
  );
  setTrackObjGlobalData(trackObject);
  trackObject[MIXPANEL_COHORT_DISCOUNT_PERCENT] = mixpanelObject.getProperty(
    MIXPANEL_COHORT_DISCOUNT_PERCENT
  );
  trackObject[MIXPANEL_UNIQUE_ID] =
    mixpanelObject.getProperty(MIXPANEL_UNIQUE_ID);
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_SUBSCRIPTION_PAGE_VIEWED,
    trackObject
  );

  //Clevertap
  clevertapEventPush(MIXPANEL_EVENTS_SUBSCRIPTION_PAGE_VIEWED, trackObject);

  //Newrelic event
  trackEvent(MIXPANEL_EVENTS_SUBSCRIPTION_PAGE_VIEWED, trackObject);
};

export const setTrackObjGlobalData = (trackObject: { [key: string]: any }) => {
  trackObject[MIXPANEL_CITY] = mixpanelObject.getProperty(MIXPANEL_CITY);
  trackObject[MIXPANEL_STATE] = mixpanelObject.getProperty(MIXPANEL_STATE);
  trackObject[MIXPANEL_REGISTRING_COUNTRY] = mixpanelObject.getProperty(
    MIXPANEL_REGISTRING_COUNTRY
  );

  trackObject[MIXPANEL_SUBSCRIPTION_STATUS] = mixpanelObject.getProperty(
    MIXPANEL_SUBSCRIPTION_STATUS
  );
  trackObject[MIXPANEL_DAYS_TO_EXPIRY] = mixpanelObject.getProperty(
    MIXPANEL_DAYS_TO_EXPIRY
  );
};
// reset the pagename and source
export const pageNameSetter = (mixpanelObject: { [key: string]: any }) => {
  const obj = mixpanelObject;
  mixpanelObject[MIXPANEL_SOURCE] = obj[MIXPANEL_PAGE_NAME];
};

// mixpanel events content properties initializer (used by mixpanel event)
export const contentPropertiesCompressor = (
  mixpanelObject: { [key: string]: any },
  trackObject: { [key: string]: any },
  withCarousal = true,
  withImageURL = false,
  withExternalLink = true
) => {
  trackObject[MIXPANEL_CONTENT_NAME] = mixpanelObject[MIXPANEL_CONTENT_NAME]; // true - PI - PR - RC
  trackObject[MIXPANEL_CONTENT_ID] = mixpanelObject[MIXPANEL_CONTENT_ID]; // true - PI - PR - RC
  trackObject[MIXPANEL_CONTENT_TYPE] = mixpanelObject[MIXPANEL_CONTENT_TYPE]; // true - PI - PR
  trackObject[MIXPANEL_CONTENT_BILLING_TYPE] =
    mixpanelObject[MIXPANEL_CONTENT_BILLING_TYPE];
  trackObject[MIXPANEL_GENRE] = mixpanelObject[MIXPANEL_GENRE]; // true - PI - PR - RC
  trackObject[MIXPANEL_CHARACTERS] = mixpanelObject[MIXPANEL_CHARACTERS]; // true - PI - PR - RC
  trackObject[MIXPANEL_CONTENT_DURATION] =
    mixpanelObject[MIXPANEL_CONTENT_DURATION]; // true - PI - PR - RC
  trackObject[MIXPANEL_PUBLISHING_DATE] =
    mixpanelObject[MIXPANEL_PUBLISHING_DATE];
  trackObject[MIXPANEL_SERIES] = mixpanelObject[MIXPANEL_SERIES];
  trackObject[MIXPANEL_EPISODE_NO] = mixpanelObject[MIXPANEL_EPISODE_NO];
  trackObject[MIXPANEL_TOP_CATEGORY] = mixpanelObject[MIXPANEL_TOP_CATEGORY]; // true - PI - PR - RC
  trackObject[MIXPANEL_CONTENT_SPECIFICATION] =
    mixpanelObject[MIXPANEL_CONTENT_SPECIFICATION]; // true - PI - PR - RC
  trackObject[MIXPANEL_CHANNEL_NAME] = mixpanelObject[MIXPANEL_CHANNEL_NAME]; // true - PI - PR - RC
  trackObject[MIXPANEL_SUBTITLES] = mixpanelObject[MIXPANEL_SUBTITLES]; // true - PI - PR - RC
  trackObject[MIXPANEL_CONTENT_ORIGIAL_LANGUAGE] =
    mixpanelObject[MIXPANEL_CONTENT_ORIGIAL_LANGUAGE]; // true - PI - PR - RC
  trackObject[MIXPANEL_AUDIO_LANGUAGE] =
    mixpanelObject[MIXPANEL_AUDIO_LANGUAGE]; // true - PI - PR - RC
  trackObject[MIXPANEL_SUBTITLE_LANGUAGE] =
    mixpanelObject[MIXPANEL_SUBTITLE_LANGUAGE]; // true - PI - PR - RC
  if (withExternalLink) {
    trackObject[MIXPANEL_EXTERNAL_LINK] =
      mixpanelObject[MIXPANEL_EXTERNAL_LINK];
  }
  if (withImageURL) {
    trackObject[MIXPANEL_IMAGE_URL] = mixpanelObject[MIXPANEL_IMAGE_URL];
  }
  if (withCarousal) {
    trackObject[MIXPANEL_CAROUSAL_NAME] =
      mixpanelObject[MIXPANEL_CAROUSAL_NAME];
    trackObject[MIXPANEL_CAROUSAL_ID] = mixpanelObject[MIXPANEL_CAROUSAL_ID];
    trackObject[MIXPANEL_VERTICAL_INDEX] =
      mixpanelObject[MIXPANEL_VERTICAL_INDEX];
    trackObject[MIXPANEL_HORIZONTAL_INDEX] =
      mixpanelObject[MIXPANEL_HORIZONTAL_INDEX];
  }
};

// pop up CTA event method
export const popupCTAEvent = (
  isPwaPopup = false,
  isViPopup = false,
  isPremiumContentFlag = false
) => {
  // no Element for launch
  // if (typeof window !== "undefined" && window.mixpanel) {
  const trackObject = basicInitializer(mixpanelObject, true);
  if (!isViPopup) {
    contentPropertiesCompressor(mixpanelObject, trackObject, false);
  }
  trackObject[MIXPANEL_DIRECTION] =
    mixpanelObject.getProperty(MIXPANEL_DIRECTION);
  trackObject[MIXPANEL_POP_UP_NAME] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_NAME);
  trackObject[MIXPANEL_POP_UP_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_TYPE);
  trackObject[MIXPANEL_BUTTON_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_BUTTON_TYPE);
  trackObject[MIXPANEL_ELEMENT] = mixpanelObject.getProperty(MIXPANEL_ELEMENT);
  if (isPwaPopup) {
    trackObject[MIXPANEL_TOP_CATEGORY] = 'N/A';
    trackObject[MIXPANEL_CONTENT_SPECIFICATION] = 'N/A';
  }
  trackObject[MIXPANEL_POP_UP_GROUP] = mixpanelObject.getProperty(
    MIXPANEL_POP_UP_GROUP
  );
  trackObject[MIXPANEL_IS_SUBSCRIPTION_FLOW] = mixpanelObject.getProperty(
    MIXPANEL_IS_SUBSCRIPTION_FLOW
  );
  trackObject[MIXPANEL_METHOD] = mixpanelObject.getProperty(MIXPANEL_METHOD);
  if (isPremiumContentFlag) {
    trackObject[MIXPANEL_IS_PREMIUM_CONTENT] =
      mixpanelObject[MIXPANEL_IS_PREMIUM_CONTENT];
  }
  mixpanelObject.trackEvent(MIXPANEL_EVENTS_POP_UP_CTAS, trackObject);
  //Clevertap event
  clevertapEventPush(MIXPANEL_EVENTS_POP_UP_CTAS, trackObject);
};

// subscription selected event method
export const subscriptionSelectedEvent = () => {
  if (typeof window !== 'undefined' && window.mixpanel) {
    const trackObject = basicInitializer(mixpanelObject, true);
    trackObject[MIXPANEL_PACK_SELECTED] =
      mixpanelObject[MIXPANEL_PACK_SELECTED as keyof typeof mixpanelObject];
    trackObject[MIXPANEL_COST] =
      mixpanelObject[MIXPANEL_COST as keyof typeof mixpanelObject];
    trackObject[MIXPANEL_CURRENT_SUBSCRIPTION] =
      mixpanelObject[
        MIXPANEL_CURRENT_SUBSCRIPTION as keyof typeof mixpanelObject
      ];
    trackObject[MIXPANEL_TRANSACTION_CURRENCY] =
      mixpanelObject[
        MIXPANEL_TRANSACTION_CURRENCY as keyof typeof mixpanelObject
      ];
    trackObject[MIXPANEL_POP_UP_NAME] =
      mixpanelObject[MIXPANEL_POP_UP_NAME as keyof typeof mixpanelObject] ||
      'N/A';
    trackObject[MIXPANEL_POP_UP_TYPE] =
      mixpanelObject[MIXPANEL_POP_UP_TYPE as keyof typeof mixpanelObject] ||
      'N/A';
    trackObject[MIXPANEL_POP_UP_GROUP] =
      mixpanelObject[MIXPANEL_POP_UP_GROUP as keyof typeof mixpanelObject] ||
      'N/A';
    trackObject[MIXPANEL_IS_UPGRADE] =
      mixpanelObject[MIXPANEL_IS_UPGRADE as keyof typeof mixpanelObject];
    trackObject[MIXPANEL_ACTUAL_COST] =
      mixpanelObject[MIXPANEL_ACTUAL_COST as keyof typeof mixpanelObject];
    trackObject[MIXPANEL_IS_RENTAL] =
      mixpanelObject[MIXPANEL_IS_RENTAL as keyof typeof mixpanelObject];
    trackObject[MIXPANEL_IS_SUBSCRIPTION_FLOW] =
      mixpanelObject[
        MIXPANEL_IS_SUBSCRIPTION_FLOW as keyof typeof mixpanelObject
      ];
    trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
    trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';
    trackObject[MIXPANEL_COHORT_ID] =
      mixpanelObject.getProperty(MIXPANEL_COHORT_ID);
    trackObject[MIXPANEL_COUPON_CODE] =
      mixpanelObject.getProperty(MIXPANEL_COUPON_CODE);
    setTrackObjGlobalData(trackObject);
    trackObject[MIXPANEL_COHORT_DISCOUNT_PERCENT] = mixpanelObject.getProperty(
      MIXPANEL_COHORT_DISCOUNT_PERCENT
    );
    trackObject[MIXPANEL_UNIQUE_ID] =
      mixpanelObject.getProperty(MIXPANEL_UNIQUE_ID);
    mixpanelObject.queueMixpanelEvents(
      MIXPANEL_EVENTS_SUBSCRIPTION_SELECTED,
      trackObject
    );
    clevertapEventPush(MIXPANEL_EVENTS_SUBSCRIPTION_SELECTED, trackObject);
    trackEvent(MIXPANEL_SUBSCRIPTION_CTA_CLICK, trackObject);
  }
};

// subscription call initiated event method
export const subscriptionCallInitiatedEvent = (isCombo = false) => {
  // isGlobal will be true for global payment through Adyen process
  const isGlobal =
    mixpanelObject.getProperty(MIXPANEL_BILLING_COUNTRY) !== 'IN';
  const trackObject = basicInitializer(mixpanelObject, isGlobal);
  trackObject[MIXPANEL_BANK_NAME] =
    mixpanelObject.getProperty(MIXPANEL_BANK_NAME);
  trackObject[MIXPANEL_CARD_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_CARD_TYPE);
  trackObject[MIXPANEL_PAYMENT_METHOD] = mixpanelObject.getProperty(
    MIXPANEL_PAYMENT_METHOD
  );
  trackObject[MIXPANEL_PACK_SELECTED] = mixpanelObject.getProperty(
    MIXPANEL_PACK_SELECTED
  );
  trackObject[MIXPANEL_COST] = mixpanelObject.getProperty(MIXPANEL_COST);
  trackObject[MIXPANEL_CURRENT_SUBSCRIPTION] = mixpanelObject.getProperty(
    MIXPANEL_CURRENT_SUBSCRIPTION
  );
  trackObject[MIXPANEL_TRANSACTION_CURRENCY] = mixpanelObject.getProperty(
    MIXPANEL_TRANSACTION_CURRENCY
  );
  trackObject[MIXPANEL_BILLING_COUNTRY] = mixpanelObject.getProperty(
    MIXPANEL_BILLING_COUNTRY
  );
  trackObject[MIXPANEL_BILLING_STATE] = mixpanelObject.getProperty(
    MIXPANEL_BILLING_STATE
  );
  trackObject[MIXPANEL_PROMO_CODE] =
    mixpanelObject.getProperty(MIXPANEL_PROMO_CODE);
  trackObject[MIXPANEL_PROMO_CODE_TYPE] = mixpanelObject.getProperty(
    MIXPANEL_PROMO_CODE_TYPE
  );
  trackObject[MIXPANEL_POP_UP_NAME] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_NAME) || 'N/A';
  trackObject[MIXPANEL_POP_UP_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_TYPE) || 'N/A';
  trackObject[MIXPANEL_POP_UP_GROUP] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_GROUP) || 'N/A';
  trackObject[MIXPANEL_IS_UPGRADE] =
    mixpanelObject.getProperty(MIXPANEL_IS_UPGRADE);
  trackObject[MIXPANEL_ACTUAL_COST] =
    mixpanelObject.getProperty(MIXPANEL_ACTUAL_COST);
  trackObject[MIXPANEL_IS_RENTAL] =
    mixpanelObject.getProperty(MIXPANEL_IS_RENTAL);
  trackObject[MIXPANEL_IS_SUBSCRIPTION_FLOW] = mixpanelObject.getProperty(
    MIXPANEL_IS_SUBSCRIPTION_FLOW
  );
  if (
    isGlobal ||
    mixpanelObject.getProperty(MIXPANEL_PAYMENT_METHOD) ===
      MIXPANEL_QWIKCILVER ||
    isCombo
  ) {
    trackObject[MIXPANEL_PAYMENT_GATEWAY] = mixpanelObject.getProperty(
      MIXPANEL_PAYMENT_GATEWAY
    );
  }
  trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
  trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';
  trackObject[MIXPANEL_COHORT_ID] =
    mixpanelObject.getProperty(MIXPANEL_COHORT_ID);
  trackObject[MIXPANEL_COUPON_CODE] =
    mixpanelObject.getProperty(MIXPANEL_COUPON_CODE);
  trackObject[MIXPANEL_COHORT_DISCOUNT_PERCENT] = mixpanelObject.getProperty(
    MIXPANEL_COHORT_DISCOUNT_PERCENT
  );
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_SUBSCRIPTION_CALL_INITIATED,
    trackObject
  );
  trackObject[MIXPANEL_SELECTION_SOURCE] = mixpanelObject.getProperty(
    MIXPANEL_SELECTION_SOURCE
  );
  clevertapEventPush(MIXPANEL_EVENTS_SUBSCRIPTION_CALL_INITIATED, trackObject);
  trackEvent(
    MIXPANEL_EVENTS_SUBSCRIPTION_CALL_INITIATED,
    trackObject,
    MIXPANEL_PAYMENT_METHOD,
    trackObject[MIXPANEL_PAYMENT_METHOD]
  );
};

// display language changed event method
export const displayLanguageChangedEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_TAB_NAME] =
    mixpanelObject.getProperty(MIXPANEL_TAB_NAME);
  trackObject[MIXPANEL_OLD_APP_LANGUAGE] = mixpanelObject.getProperty(
    MIXPANEL_OLD_APP_LANGUAGE
  );
  trackObject[MIXPANEL_POP_UP_NAME] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_NAME);
  trackObject[MIXPANEL_POP_UP_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_TYPE);
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_DISPLAY_LANGUAGE_CHANGE,
    trackObject
  );
};

// content language changed event method
export const contentLanguageChangedEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_TAB_NAME] =
    mixpanelObject.getProperty(MIXPANEL_TAB_NAME);
  trackObject[MIXPANEL_OLD_CONTENT_LANGUAGE] = mixpanelObject.getProperty(
    MIXPANEL_OLD_CONTENT_LANGUAGE
  );
  trackObject[MIXPANEL_POP_UP_NAME] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_NAME);
  trackObject[MIXPANEL_POP_UP_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_TYPE);
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_CONTENT_LANGUAGE_CHANGE,
    trackObject
  );
};
// subscription pack toggle event
export const packToggleEvent = () => {
  if (typeof window !== 'undefined' && window.mixpanel) {
    const trackObject = basicInitializer(mixpanelObject, true);
    trackObject[MIXPANEL_COUNTER] =
      mixpanelObject.getProperty(MIXPANEL_COUNTER);
    trackObject[MIXPANEL_UNIQUE_ID] =
      mixpanelObject.getProperty(MIXPANEL_UNIQUE_ID);
    aggregatorEventHelper(trackObject);
    mixpanelObject.queueMixpanelEvents(
      MIXPANEL_EVENTS_PACK_TOGGLE,
      trackObject
    );
    clevertapEventPush(MIXPANEL_EVENTS_PACK_TOGGLE, trackObject);
    trackEvent(MIXPANEL_SUBSCRIPTION_PACK_TOGGLE, trackObject);
  }
};

// app Session event method
export const sessionEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_LOAD_TIME] =
    mixpanelObject.getProperty(MIXPANEL_LOAD_TIME);
  mixpanelObject.queueMixpanelEvents(MIXPANEL_EVENTS_SESSION, trackObject);
  clevertapEventPush(MIXPANEL_EVENTS_SESSION, trackObject);
};

// TODO: Move this function to proper file
export const checkKidsCard = (genres: any) => {
  let isKidCard = false;
  let isEduaraCard = false;
  if (genres) {
    genres.forEach((ele: any) => {
      const { id = '' } = ele || {};
      if (id === 'Kids' || id === 'Kid') {
        isKidCard = true;
      } else if (id === 'Education') {
        isEduaraCard = true;
      }
    });
  }
  return isKidCard && !isEduaraCard;
};

// top catagory property identifier
export const getTopCategory = (data: any) => {
  let topCategory = 'N/A';
  const isKids = checkKidsCard(data.genre || data.genres);
  if (data && (data.asset_type || data.assetType) === 0) {
    if (
      (data.asset_subtype || data.assetSubType) &&
      (data.asset_subtype?.indexOf('movie') > -1 ||
        data.assetSubType?.indexOf('movie') > -1)
    ) {
      topCategory = isKids ? 'Kids Movies' : 'Movie';
    } else if (
      (data.asset_subtype || data.assetSubType) &&
      (data.asset_subtype?.indexOf('video') > -1 ||
        data.assetSubType?.indexOf('movie') > -1)
    ) {
      const genres = data.genre || data.genres;
      if (
        genres.filter((item: any) => item.id.toLowerCase().includes('news'))
          .length
      ) {
        topCategory = isKids ? 'Kids News' : 'News';
      } else if (
        genres.filter((item: any) => item.id.toLowerCase().includes('music'))
          .length
      ) {
        topCategory = isKids ? 'Kids Music' : 'Music';
      } else {
        // if not originals
        topCategory = isKids ? 'Kids Video' : 'Video';
      }
    } else {
      topCategory = isKids ? 'Kids Movies' : 'Movie';
    }
  } else if (data && (data.asset_type || data.assetType) === 1) {
    const tvshowInfo =
      data &&
      (data.tvshow ||
        data.tvshows ||
        data.tvshow_detail ||
        data.tvshow_details);
    if (
      tvshowInfo &&
      (tvshowInfo.asset_subtype || tvshowInfo.assetSubType) &&
      ((tvshowInfo.asset_subtype &&
        tvshowInfo.asset_subtype.indexOf('original') > -1) ||
        (tvshowInfo.assetSubType &&
          tvshowInfo.assetSubType.indexOf('original') > -1))
    ) {
      topCategory = isKids ? 'Kids Original' : 'Original';
    } else {
      topCategory = isKids ? 'Kids Tv Show' : 'Tv Show';
    }
    if (
      (data.asset_subtype || data.assetSubType) === 'live_event' ||
      (data.asset_subtype || data.assetSubType) === 'sports_vod'
    ) {
      topCategory = ILT20_TOP_CATEGORY_NAME;
    }
  } else if (data && data.asset_type === 6) {
    topCategory = isKids
      ? `Kids ${data.asset_subtype || data.assetSubType}`
      : data.asset_subtype || data.assetSubType;
  } else if (data && (data.asset_subtype || data.assetSubType)) {
    topCategory = data.asset_subtype || data.assetSubType;
  }
  return topCategory;
};

export const getContentSpecification = (
  assetType: ASSET_TYPE,
  assetSubtype: string
) => {
  let contentSpecification = 'N/A';
  if (assetType === ASSET_TYPE.Movie) {
    contentSpecification = assetSubtype;
  }
  if (assetType === ASSET_TYPE.Episode || assetType === ASSET_TYPE.TvShow) {
    contentSpecification = 'video';
  } else if (assetType === ASSET_TYPE.Channel) {
    contentSpecification = CHANNEL_GUIDE_CONSTANTS.CHANNEL;
  }
  return contentSpecification;
};

// Business type check for getting premium content
// TODO: Move this function to consumption helper or the file which has common utils
export const businessType = (
  type: string,
  billingType: string,
  isEduauraa = false
) => {
  if (
    type === 'premium' ||
    type === 'premium_downloadable' ||
    billingType === 'club' ||
    billingType === 'premium' ||
    isEduauraa
  ) {
    return true;
  }
  return false;
};

// returns billing type of content
// TODO: Move this to consumption helper or the file which has common utils
export const contentBillingType = (type: string, billingType: string) => {
  let contentType = '';
  if (
    type === ' tvod_downloadable' ||
    type === 'tvod' ||
    type === 'tvod_downloadable'
  ) {
    contentType = 'tvod';
  } else if (businessType(type, billingType)) {
    contentType = billingType === 'club' ? 'club' : 'premium';
  }
  return contentType;
};

// TODO: Move this to consumption helper or the file which has common utils
export const iltConsumptionCheck = (bothIltConsumptionCheck?: boolean) => {
  const url =
    typeof window !== 'undefined' &&
    window.location.pathname &&
    window.location.pathname;
  let consumptionType = '';
  if (
    (url && url.includes(SPORTS_ROUTE) && url && url.split('/').length >= 7) ||
    (url && url.includes('/live-streaming/'))
  ) {
    if (bothIltConsumptionCheck) {
      return 'iltConsumption';
    } else {
      consumptionType =
        url && url.includes('/live-streaming/')
          ? 'iltConsumptionLive'
          : 'iltConsumptionVod';
      return consumptionType;
    }
  }
  return false;
};

// TODO: Assign proper types for params and variabales
export const contentRentalMixpanelSetter = (
  mixpanelObject: any,
  contentItem: any,
  activeRentalData: any,
  minutesToExpiry: string
) => {
  if (activeRentalData.length && Object.keys(activeRentalData[0]).length) {
    const item = activeRentalData[0];
    mixpanelObject[MIXPANEL_MINUTES_TO_EXPIRY] = minutesToExpiry || 'N/A';
    mixpanelObject[MIXPANEL_IS_RENTAL] = true;
    mixpanelObject[MIXPANEL_RENTAL_RELEASE_DATE] =
      contentItem.release_date || 'N/A';
    mixpanelObject[MIXPANEL_RENTAL_EXPIRY_DATE] =
      contentItem.license_expiry_date || 'N/A';
    mixpanelObject[MIXPANEL_RENTAL_PURCHASE_DATE] = item.date || 'N/A';
    mixpanelObject[MIXPANEL_RENTAL_PURCHASE_EXPIRY_DATE] =
      item.purchase_end || 'N/A';
    mixpanelObject[MIXPANEL_ACTUAL_COST] =
      item.subscription_plan.price || 'N/A';
    mixpanelObject[MIXPANEL_COST] =
      item.subscription_plan.discount && item.subscription_plan.discount
        ? item.subscription_plan.price - item.subscription_plan.discount
        : item.subscription_plan.price || 'N/A';
  }
};

// mixpanel events content property setter (used by triggering events)
// TODO: Assign proper types for params and variabales
export const contentPropertySetter = (
  mixpanelObject: any,
  data: any,
  indexObject: any,
  withCarousal = true
) => {
  if (!data) {
    return;
  }
  const tvShow = data.asset_type === 1;
  const audioLanguages = data.audioLanguages || data.audioLanguages;
  const subtitleLanguages = data.subtitleLanguages || data.subtitle_languages;
  let genres;
  if (data.genre) {
    genres =
      (data.genre &&
        data.genre.length &&
        data.genre.map((elem: any) => elem.id)) ||
      'N/A';
  } else {
    genres =
      (data.genres &&
        data.genres.length &&
        data.genres.map((elem: any) => elem.id)) ||
      'N/A';
  }
  mixpanelObject[MIXPANEL_CONTENT_NAME] =
    data.original_title || data.title || 'N/A';
  mixpanelObject[MIXPANEL_CONTENT_ID] = data.id || 'N/A';
  mixpanelObject[MIXPANEL_CONTENT_TYPE] =
    data.business_type || data.businessType || 'N/A';
  mixpanelObject[MIXPANEL_CONTENT_BILLING_TYPE] =
    data.billing_type || data.billingType || 'N/A';
  mixpanelObject[MIXPANEL_GENRE] = genres;
  mixpanelObject[MIXPANEL_CHARACTERS] =
    data.actors && data.actors.length ? data.actors : 'N/A';
  mixpanelObject[MIXPANEL_CONTENT_DURATION] = data.duration || 'N/A';
  mixpanelObject[MIXPANEL_PUBLISHING_DATE] =
    data.release_date || data.releaseDate || 'N/A';
  mixpanelObject[MIXPANEL_SERIES] = tvShow
    ? (data.tvshow?.original_title && data.tvshow?.originalTitle) ||
      (data.tvshow_details?.originalTitle &&
        data.tvshow_details?.original_title) ||
      data.tvshow_name ||
      'N/A'
    : data.original_title || 'N/A';
  mixpanelObject[MIXPANEL_EPISODE_NO] = tvShow
    ? data.episode_number || data.episodeNumber
    : 'N/A';
  mixpanelObject[MIXPANEL_TOP_CATEGORY] = getTopCategory(data);
  mixpanelObject[MIXPANEL_CONTENT_SPECIFICATION] = getContentSpecification(
    data.asset_type,
    data.asset_subtype
  );
  mixpanelObject[MIXPANEL_CHANNEL_NAME] =
    (data.channels && data.channels[0] && data.channels[0].original_title) ||
    'N/A';
  mixpanelObject[MIXPANEL_SUBTITLES] = !!(
    data.subtitle_languages &&
    data.subtitle_languages.length > 0 &&
    data.subtitle_languages[0] !== ''
  );
  mixpanelObject[MIXPANEL_CONTENT_ORIGIAL_LANGUAGE] =
    (data.languages && data.languages[0]) || 'N/A';
  mixpanelObject[MIXPANEL_AUDIO_LANGUAGE] = audioLanguages || 'N/A';
  mixpanelObject[MIXPANEL_SUBTITLE_LANGUAGE] = subtitleLanguages || 'N/A';
  mixpanelObject[MIXPANEL_CAROUSAL_NAME] = 'N/A';
  mixpanelObject[MIXPANEL_CAROUSAL_ID] = 'N/A';
  mixpanelObject[MIXPANEL_VERTICAL_INDEX] = 'N/A';
  mixpanelObject[MIXPANEL_HORIZONTAL_INDEX] = 'N/A';
  mixpanelObject[MIXPANEL_IMAGE_URL] = data.image_url || 'N/A';
  const contentType = contentBillingType(data.business_type, data.billing_type);
  mixpanelObject[MIXPANEL_IS_RENTAL] = contentType === 'tvod';
  const channelDetailsCheck =
    data.web_slug && data.web_slug.includes('channels/details/');
  if (iltConsumptionCheck() === 'iltConsumptionLive' || channelDetailsCheck) {
    mixpanelObject[MIXPANEL_IS_LIVE] =
      iltConsumptionCheck() === 'iltConsumptionLive' ||
      channelDetailsCheck ||
      false;
  }
  if (contentType === 'tvod') {
    mixpanelObject[MIXPANEL_RENTAL_RELEASE_DATE] = data.release_date || 'N/A';
    mixpanelObject[MIXPANEL_RENTAL_EXPIRY_DATE] =
      data.license_expiry_date || 'N/A';
  }
  // mixpanelObject[ MIXPANEL_EXTERNAL_LINK ] = data.link || data.permalink || "N/A";
  if (withCarousal && indexObject) {
    mixpanelObject[MIXPANEL_CAROUSAL_NAME] =
      indexObject.title || indexObject.originalTitle || 'N/A';
    mixpanelObject[MIXPANEL_CAROUSAL_ID] =
      indexObject.contentId || indexObject.id || 'N/A';
    mixpanelObject[MIXPANEL_VERTICAL_INDEX] =
      indexObject.index || indexObject.verticalIndex || 'N/A';
    mixpanelObject[MIXPANEL_HORIZONTAL_INDEX] =
      indexObject.horizontalIndex || 'N/A';
  }
};

// popup launch event method
export const popupLaunchEvent = (isPwaPopup = false, isViPopup = false) => {
  // no Element for launch
  const trackObject = basicInitializer(mixpanelObject);
  if (!isViPopup) {
    contentPropertiesCompressor(mixpanelObject, trackObject, false);
  }
  trackObject[MIXPANEL_DIRECTION] =
    mixpanelObject.getProperty(MIXPANEL_DIRECTION);
  trackObject[MIXPANEL_POP_UP_NAME] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_NAME);
  trackObject[MIXPANEL_POP_UP_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_TYPE);
  if (isPwaPopup) {
    trackObject[MIXPANEL_TOP_CATEGORY] = 'N/A';
    trackObject[MIXPANEL_CONTENT_SPECIFICATION] = 'N/A';
  }
  trackObject[MIXPANEL_IS_RENTAL] =
    mixpanelObject.getProperty(MIXPANEL_IS_RENTAL);
  trackObject[MIXPANEL_POP_UP_GROUP] = mixpanelObject.getProperty(
    MIXPANEL_POP_UP_GROUP
  );
  trackObject[MIXPANEL_IS_SUBSCRIPTION_FLOW] = mixpanelObject.getProperty(
    MIXPANEL_IS_SUBSCRIPTION_FLOW
  );
  trackObject[MIXPANEL_ELEMENT] = mixpanelObject.getProperty(MIXPANEL_ELEMENT);
  mixpanelObject.trackEvent(MIXPANEL_EVENTS_POPUP_LAUNCH, trackObject);
  clevertapEventPush(MIXPANEL_EVENTS_POPUP_LAUNCH, trackObject);
};

// Player Cta Event - TVOD
export const playerCtaEvent = (isPremiumContentFlag = false) => {
  const trackObject = basicInitializer(mixpanelObject, true);
  trackObject[MIXPANEL_TAB_NAME] =
    mixpanelObject.getProperty(MIXPANEL_TAB_NAME);
  contentPropertiesCompressor(mixpanelObject, trackObject, true, false);
  delete trackObject[MIXPANEL_CONTENT_BILLING_TYPE];
  delete trackObject[MIXPANEL_PUBLISHING_DATE];
  delete trackObject[MIXPANEL_SERIES];
  delete trackObject[MIXPANEL_EPISODE_NO];
  delete trackObject[MIXPANEL_EXTERNAL_LINK];
  trackObject[MIXPANEL_BUTTON_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_BUTTON_TYPE);
  trackObject[MIXPANEL_IS_RENTAL] =
    mixpanelObject.getProperty(MIXPANEL_IS_RENTAL);
  trackObject[MIXPANEL_ELEMENT] = mixpanelObject.getProperty(MIXPANEL_ELEMENT);
  if (isPremiumContentFlag) {
    trackObject[MIXPANEL_IS_PREMIUM_CONTENT] = mixpanelObject.getProperty(
      MIXPANEL_IS_PREMIUM_CONTENT
    );
  }
  if (mixpanelObject.getProperty(MIXPANEL_CONTENT_TYPE) === 'tvod') {
    trackObject[MIXPANEL_RENTAL_RELEASE_DATE] = mixpanelObject.getProperty(
      MIXPANEL_RENTAL_RELEASE_DATE
    );
    trackObject[MIXPANEL_RENTAL_EXPIRY_DATE] = mixpanelObject.getProperty(
      MIXPANEL_RENTAL_EXPIRY_DATE
    );
    trackObject[MIXPANEL_RENTAL_PURCHASE_DATE] = mixpanelObject.getProperty(
      MIXPANEL_RENTAL_PURCHASE_DATE
    );
    trackObject[MIXPANEL_RENTAL_PURCHASE_EXPIRY_DATE] =
      mixpanelObject.getProperty(MIXPANEL_RENTAL_PURCHASE_EXPIRY_DATE);
    trackObject[MIXPANEL_MINUTES_TO_EXPIRY] = mixpanelObject.getProperty(
      MIXPANEL_MINUTES_TO_EXPIRY
    );
    trackObject[MIXPANEL_COST] = mixpanelObject.getProperty(MIXPANEL_COST);
    trackObject[MIXPANEL_ACTUAL_COST] =
      mixpanelObject.getProperty(MIXPANEL_ACTUAL_COST);
  }

  aggregatorEventHelper(trackObject);
  mixpanelObject.queueMixpanelEvents(MIXPANEL_EVENTS_PLAYER_CTAS, trackObject);
  clevertapEventPush(MIXPANEL_EVENTS_PLAYER_CTAS, trackObject);
};

export const contentLanguageBannerEvent = (impression = false) => {
  const trackObject = basicInitializer(mixpanelObject, true);
  trackObject[MIXPANEL_PAGE_NAME] =
    mixpanelObject.getProperty(MIXPANEL_PAGE_NAME);

  trackObject[MIXPANEL_SOURCE] = mixpanelObject.getProperty(MIXPANEL_SOURCE);

  trackObject[MIXPANEL_ELEMENT] = mixpanelObject.getProperty(MIXPANEL_ELEMENT);

  trackObject[MIXPANEL_WIDGET_NAME] =
    mixpanelObject.getProperty(MIXPANEL_WIDGET_NAME);

  const eventName = impression
    ? MIXPANEL_EVENTS_WIDGET_IMPRESSION_EVENT
    : MIXPANEL_EVENTS_WIDGET_CTA_EVENT;
  mixpanelObject.queueMixpanelEvents(eventName, trackObject);
  clevertapEventPush(eventName, trackObject);
};
//Telco user login
// export const telcoUserLoginEvent = (mixpanelObject: DynamicObject) => {
//   const trackObject = basicInitializer(mixpanelObject);
//   screenViewEvent();
//   mixpanelObject.queueMixpanelEvents({ ...trackObject, mixpanelObject });
// };

// Gamification Widget CTA Event
export const widgetCTAEvent = (impression = false, isTvod = false) => {
  // pass first argument as true to triggers widget impression
  // pass second argument as true if its TVOD
  const trackObject = basicInitializer(mixpanelObject, true);
  trackObject[MIXPANEL_PAGE_NAME] =
    mixpanelObject.getProperty(MIXPANEL_PAGE_NAME);
  trackObject[MIXPANEL_SOURCE] = mixpanelObject.getProperty(MIXPANEL_SOURCE);
  trackObject[MIXPANEL_BUTTON_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_BUTTON_TYPE);
  trackObject[MIXPANEL_VERTICAL_INDEX] = mixpanelObject.getProperty(
    MIXPANEL_VERTICAL_INDEX || 'N/A'
  );
  if (!isTvod) {
    if (mixpanelObject[MIXPANEL_PAGE_NAME] === ILT20_CONSUMPTION_PAGE) {
      trackObject[MIXPANEL_WIDGET_NAME] =
        mixpanelObject.getProperty(MIXPANEL_WIDGET_NAME);
    } else {
      trackObject[MIXPANEL_PLATFORM_SECTION] = mixpanelObject.getProperty(
        MIXPANEL_PLATFORM_SECTION
      );
    }
  } else {
    trackObject[MIXPANEL_WIDGET_NAME] =
      mixpanelObject.getProperty(MIXPANEL_WIDGET_NAME);
    trackObject[MIXPANEL_IS_RENTAL] =
      mixpanelObject.getProperty(MIXPANEL_IS_RENTAL);
  }
  const eventName = impression
    ? MIXPANEL_EVENTS_WIDGET_IMPRESSION_EVENT
    : MIXPANEL_EVENTS_WIDGET_CTA_EVENT;
  mixpanelObject.trackEvent(eventName, trackObject);
};

export const loginScreenDisplayEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_LOGIN_SCREEN_DISPLAY,
    trackObject
  );
  clevertapEventPush(MIXPANEL_EVENTS_LOGIN_SCREEN_DISPLAY, trackObject);
};

export const loginInitiatedEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_METHOD] = mixpanelObject.getProperty(MIXPANEL_METHOD);
  trackObject[MIXPANEL_SOCIAL_NETWORK] = mixpanelObject.getProperty(
    MIXPANEL_SOCIAL_NETWORK
  );
  trackObject[MIXPANEL_SELECT_BY] =
    mixpanelObject.getProperty(MIXPANEL_SELECT_BY);
  trackObject[MIXPANEL_ELEMENT] = mixpanelObject.getProperty(MIXPANEL_ELEMENT);
  trackObject[MIXPANEL_IS_SUBSCRIPTION_FLOW] = mixpanelObject.getProperty(
    MIXPANEL_IS_SUBSCRIPTION_FLOW
  );
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_LOGIN_INITIATED,
    trackObject
  );
  clevertapEventPush(MIXPANEL_EVENTS_LOGIN_INITIATED, trackObject);
};

export const loginResultEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_METHOD] = mixpanelObject.getProperty(MIXPANEL_METHOD);
  trackObject[MIXPANEL_SOCIAL_NETWORK] = mixpanelObject.getProperty(
    MIXPANEL_SOCIAL_NETWORK
  );
  trackObject[MIXPANEL_SELECT_BY] =
    mixpanelObject.getProperty(MIXPANEL_SELECT_BY);
  trackObject[MIXPANEL_ELEMENT] = mixpanelObject.getProperty(MIXPANEL_ELEMENT);
  trackObject[MIXPANEL_IS_SUBSCRIPTION_FLOW] = mixpanelObject.getProperty(
    MIXPANEL_IS_SUBSCRIPTION_FLOW
  );
  trackObject[MIXPANEL_SUCCESS] = mixpanelObject.getProperty(MIXPANEL_SUCCESS);
  trackObject[MIXPANEL_FAILURE_REASON] = mixpanelObject.getProperty(
    MIXPANEL_FAILURE_REASON
  );
  trackObject[MIXPANEL_CITY] = mixpanelObject.getProperty(MIXPANEL_CITY);
  trackObject[MIXPANEL_STATE] = mixpanelObject.getProperty(MIXPANEL_STATE);

  mixpanelObject.queueMixpanelEvents(MIXPANEL_EVENTS_LOGIN_RESULT, trackObject);
  clevertapEventPush(MIXPANEL_EVENTS_LOGIN_RESULT, trackObject);
};

export const prepaidCodeResultEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_SUCCESS] = mixpanelObject.getProperty(MIXPANEL_SUCCESS);
  trackObject[MIXPANEL_FAILURE_REASON] = mixpanelObject.getProperty(
    MIXPANEL_FAILURE_REASON
  );
  trackObject[MIXPANEL_PACK_SELECTED] = mixpanelObject.getProperty(
    MIXPANEL_PACK_SELECTED
  );
  trackObject[MIXPANEL_COST] = mixpanelObject.getProperty(MIXPANEL_COST);
  trackObject[MIXPANEL_CURRENT_SUBSCRIPTION] = mixpanelObject.getProperty(
    MIXPANEL_CURRENT_SUBSCRIPTION
  );
  trackObject[MIXPANEL_TRANSACTION_CURRENCY] = mixpanelObject.getProperty(
    MIXPANEL_TRANSACTION_CURRENCY
  );
  trackObject[MIXPANEL_PREPAID_CODE] = mixpanelObject.getProperty(
    MIXPANEL_PREPAID_CODE
  );
  trackObject[MIXPANEL_PROMO_CODE_TYPE] = mixpanelObject.getProperty(
    MIXPANEL_PROMO_CODE_TYPE
  );
  trackObject[MIXPANEL_POP_UP_NAME] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_NAME) || 'N/A';
  trackObject[MIXPANEL_POP_UP_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_TYPE) || 'N/A';
  trackObject[MIXPANEL_POP_UP_GROUP] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_GROUP) || 'N/A';
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_PREPAID_CODE_RESULT,
    trackObject
  );
};

export const promoCodeResultEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_SUCCESS] = mixpanelObject.getProperty(MIXPANEL_SUCCESS);
  trackObject[MIXPANEL_FAILURE_REASON] = mixpanelObject.getProperty(
    MIXPANEL_FAILURE_REASON
  );
  trackObject[MIXPANEL_PACK_SELECTED] = mixpanelObject.getProperty(
    MIXPANEL_PACK_SELECTED
  );
  trackObject[MIXPANEL_COST] = mixpanelObject.getProperty(MIXPANEL_COST);
  trackObject[MIXPANEL_CURRENT_SUBSCRIPTION] = mixpanelObject.getProperty(
    MIXPANEL_CURRENT_SUBSCRIPTION
  );
  trackObject[MIXPANEL_TRANSACTION_CURRENCY] = mixpanelObject.getProperty(
    MIXPANEL_TRANSACTION_CURRENCY
  );
  trackObject[MIXPANEL_PROMO_CODE] =
    mixpanelObject.getProperty(MIXPANEL_PROMO_CODE);
  trackObject[MIXPANEL_PROMO_CODE_TYPE] = mixpanelObject.getProperty(
    MIXPANEL_PROMO_CODE_TYPE
  );
  trackObject[MIXPANEL_POP_UP_NAME] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_NAME) || 'N/A';
  trackObject[MIXPANEL_POP_UP_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_TYPE) || 'N/A';
  trackObject[MIXPANEL_POP_UP_GROUP] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_GROUP) || 'N/A';
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_PROMO_CODE_RESULT,
    trackObject
  );
};

export const interimSubscriptionPaymentSuccess = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_POP_UP_GROUP] = mixpanelObject[MIXPANEL_POP_UP_GROUP];
  trackObject[MIXPANEL_POP_UP_NAME] = mixpanelObject[MIXPANEL_POP_UP_NAME];
  trackObject[MIXPANEL_SUCCESS] = mixpanelObject[MIXPANEL_SUCCESS];
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_INTERIM_SUBSCRIPTION_PAYMENT_SUCCESS,
    trackObject
  );
};

// remove from favorite or watchlist event method
export const removeFromWatchlistEvent = () => {
  const trackObject = basicInitializer(mixpanelObject, true);
  contentPropertiesCompressor(mixpanelObject, trackObject, true, false);
  trackObject[MIXPANEL_TAB_NAME] = mixpanelObject[MIXPANEL_TAB_NAME];
  aggregatorEventHelper(trackObject);
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_REMOVE_FROM_WATCHLIST,
    trackObject
  );
  clevertapEventPush(MIXPANEL_EVENTS_REMOVE_FROM_WATCHLIST, trackObject);
};
// search cancelled event method
export const searchCancelledEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_SEARCH_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_SEARCH_TYPE);
  trackObject[MIXPANEL_RESULTS_RETURNED] = mixpanelObject.getProperty(
    MIXPANEL_RESULTS_RETURNED
  );
  trackObject[MIXPANEL_SEARCH_QUERY] = mixpanelObject.getProperty(
    MIXPANEL_SEARCH_QUERY
  );
  trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
  trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_SEARCH_CANCELLED_EVENT,
    trackObject
  );
};

// clear search history event method
export const clearSearchHistoryEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_EVENTS_SETTING_CHANGED] = mixpanelObject.getProperty(
    MIXPANEL_EVENTS_SETTING_CHANGED
  );
  trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
  trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_CLEAR_SEARCH_HISTORY,
    trackObject
  );
};

export const searchMicrophoneCTAEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_ELEMENT] = mixpanelObject.getProperty(MIXPANEL_ELEMENT);
  trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
  trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';
  mixpanelObject.queueMixpanelEvents(MIXPANEL_EVENTS_CTAS, trackObject);
};

// voice error displayed event
export const voiceSearchErrorEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_VOICE_ERROR_MESSAGE] = mixpanelObject.getProperty(
    MIXPANEL_VOICE_ERROR_MESSAGE
  );
  trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
  trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_VOICE_ERROR_DISPLAYED,
    trackObject
  );
};

// search button click event method
export const searchButtonClickEvent = () => {
  const trackObject = basicInitializer(mixpanelObject, true);
  trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
  trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_SEARCH_BUTTON_CLICK,
    trackObject
  );
};

// add to watchlist event method
export const addToWatchlistEvent = () => {
  if (iltConsumptionCheck()) {
    mixpanelObject[MIXPANEL_CONTENT_SPECIFICATION] = ILT20_TOP_CATEGORY_NAME;
    mixpanelObject[MIXPANEL_TOP_CATEGORY] = ILT20_TOP_CATEGORY_NAME;
    mixpanelObject[MIXPANEL_IS_LIVE] =
      iltConsumptionCheck() === 'iltConsumptionLive' || false;
  }
  const trackObject = basicInitializer(mixpanelObject, true);
  contentPropertiesCompressor(mixpanelObject, trackObject, true, false);
  aggregatorEventHelper(trackObject);
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_ADD_TO_WATCHLIST,
    trackObject
  );
  clevertapEventPush(MIXPANEL_EVENTS_ADD_TO_WATCHLIST, trackObject);
};

// Toast Message Impression
export const toastMessageImpression = () => {
  const trackObject = basicInitializer(mixpanelObject, false);
  trackObject[MIXPANEL_TOAST_MESSAGE] = mixpanelObject.getProperty(
    MIXPANEL_TOAST_MESSAGE
  );
  aggregatorEventHelper(trackObject);
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_TOAST_MESSAGE_IMPRESSION,
    trackObject
  );
};
// search cleared event method
export const searchClearedEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_SEARCH_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_SEARCH_TYPE);
  trackObject[MIXPANEL_SEARCH_QUERY] = mixpanelObject.getProperty(
    MIXPANEL_SEARCH_QUERY
  );
  trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
  trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_SEARCH_CLEARED,
    trackObject
  );
};

// search started event method
export const searchStartedEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_RECENT_SEARCH_QUERY_DISPLAYED] =
    mixpanelObject.getProperty(MIXPANEL_RECENT_SEARCH_QUERY_DISPLAYED);
  trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
  trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_SEARCH_STARTED,
    trackObject
  );
};

// share event method
export const shareEvent = () => {
  if (iltConsumptionCheck()) {
    mixpanelObject[MIXPANEL_CONTENT_SPECIFICATION] = ILT20_TOP_CATEGORY_NAME;
    mixpanelObject[MIXPANEL_TOP_CATEGORY] = ILT20_TOP_CATEGORY_NAME;
    mixpanelObject[MIXPANEL_IS_LIVE] =
      iltConsumptionCheck() === 'iltConsumptionLive' || false;
  }
  const trackObject = basicInitializer(mixpanelObject);
  contentPropertiesCompressor(mixpanelObject, trackObject, true, false);
  trackObject[MIXPANEL_SHARING_PLATFORM] = mixpanelObject.getProperty(
    MIXPANEL_SHARING_PLATFORM
  );
  aggregatorEventHelper(trackObject);
  mixpanelObject.queueMixpanelEvents(MIXPANEL_EVENTS_SHARE, trackObject);
};

//  Parental overlay display
export const parentalOverlay = (payload: DynamicObject) => {
  if (typeof window !== 'undefined' && window.mixpanel) {
    const trackObject = basicInitializer(mixpanelObject, false);
    contentPropertiesCompressor(mixpanelObject, trackObject, true, false);
    trackObject[MIXPANEL_IS_TALAMOOS] =
      mixpanelObject.getProperty(MIXPANEL_IS_TALAMOOS);
    trackObject[MIXPANEL_CAROUSAL_NAME] = payload.carouselName;
    trackObject[MIXPANEL_CAROUSAL_ID] = payload.carousalId;
    trackObject[MIXPANEL_TALAMOOS_MODELNAME] =
      payload.talamoosModelname || 'N/A';
    trackObject[MIXPANEL_TALAMOOS_ORIGIN] = mixpanelObject.getProperty(
      MIXPANEL_TALAMOOS_ORIGIN
    );
    trackObject[MIXPANEL_TALAMOOS_CLICKID] = mixpanelObject.getProperty(
      MIXPANEL_TALAMOOS_CLICKID
    );
    trackObject[MIXPANEL_PREVIEW_STATUS] = mixpanelObject.getProperty(
      MIXPANEL_PREVIEW_STATUS
    );
    trackObject[MIXPANEL_VIDEO_AUTOPLAYED] = payload.autoplay;
    const array = [
      MIXPANEL_CONTENT_ORIGIAL_LANGUAGE,
      MIXPANEL_AUDIO_LANGUAGE,
      MIXPANEL_SUBTITLES,
      MIXPANEL_SUBTITLE_LANGUAGE,
      MIXPANEL_EXTERNAL_LINK
    ];
    removeProperties(trackObject, array);
    mixpanelObject.queueMixpanelEvents(
      MIXPANEL_EVENTS_PARENTAL_OVERLAY_IMPRESSION,
      trackObject
    );
  }
};

//  Parental pin result
export const parentalOverlayResult = (payload: DynamicObject) => {
  if (typeof window !== 'undefined' && window.mixpanel) {
    const trackObject = basicInitializer(mixpanelObject, false);
    contentPropertiesCompressor(mixpanelObject, trackObject, true, false);
    trackObject[MIXPANEL_CAROUSAL_NAME] = payload.mixpanelData.carouselName;
    trackObject[MIXPANEL_CAROUSAL_ID] = payload.mixpanelData.carousalId;
    trackObject[MIXPANEL_IS_TALAMOOS] =
      mixpanelObject.getProperty(MIXPANEL_IS_TALAMOOS);
    trackObject[MIXPANEL_TALAMOOS_MODELNAME] =
      payload.mixpanelData.talamoosModelname || 'N/A';
    trackObject[MIXPANEL_TALAMOOS_ORIGIN] = mixpanelObject.getProperty(
      MIXPANEL_TALAMOOS_ORIGIN
    );
    trackObject[MIXPANEL_TALAMOOS_CLICKID] = mixpanelObject.getProperty(
      MIXPANEL_TALAMOOS_CLICKID
    );
    trackObject[MIXPANEL_PREVIEW_STATUS] = mixpanelObject.getProperty(
      MIXPANEL_PREVIEW_STATUS
    );
    trackObject[MIXPANEL_VIDEO_AUTOPLAYED] = payload.autoplay;
    trackObject[MIXPANEL_SUCCESS] =
      mixpanelObject.getProperty(MIXPANEL_SUCCESS);
    trackObject[MIXPANEL_FAILURE_REASON] = mixpanelObject.getProperty(
      MIXPANEL_FAILURE_REASON
    );
    const array = [
      MIXPANEL_CONTENT_ORIGIAL_LANGUAGE,
      MIXPANEL_SUBTITLES,
      MIXPANEL_AUDIO_LANGUAGE,
      MIXPANEL_SUBTITLE_LANGUAGE,
      MIXPANEL_EXTERNAL_LINK
    ];
    removeProperties(trackObject, array);
    mixpanelObject.queueMixpanelEvents(
      MIXPANEL_EVENTS_PARENTAL_OVERLAY_RESULT,
      trackObject
    );
  }
};

// skip login event method
export const skipLoginEvent = () => {
  const trackObject = basicInitializer(mixpanelObject, true);
  mixpanelObject.queueMixpanelEvents(MIXPANEL_EVENTS_SKIP_LOGIN, trackObject);
  gtm.loginSkipEventGTM();
};

// skip registration event method
export const skipRegistrationEvent = () => {
  const trackObject = basicInitializer(mixpanelObject, true);
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_SKIP_REGISTRATION,
    trackObject
  );
  gtm.registerSkipEventGTM();
};

// default setting restored event method
export const defaultSettingRestoredEvent = () => {
  const trackObject = basicInitializer(mixpanelObject, true);
  trackObject[MIXPANEL_EVENTS_SETTING_CHANGED] = mixpanelObject.getProperty(
    MIXPANEL_EVENTS_SETTING_CHANGED
  );
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_DEFAULT_SETTING_RESTORED,
    trackObject
  );
};

export const aggregatorEventHelper = (trackObject: { [x: string]: any }) => {
  trackObject[MIXPANEL_AGGREGATOR_PARTNER_NAME] =
    mixpanelObject.getProperty(MIXPANEL_AGGREGATOR_PARTNER_NAME) || 'N/A';
  trackObject[MIXPANEL_AGGREGATOR_PARTNER_ID] =
    mixpanelObject.getProperty(MIXPANEL_AGGREGATOR_PARTNER_ID) || 'N/A';
  trackObject[MIXPANEL_AGGREGATOR_USER_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_AGGREGATOR_USER_TYPE) || 'N/A';
  trackObject[MIXPANEL_ACTIVE_PARTNER_SUBSCRIPTION] =
    mixpanelObject.getProperty(MIXPANEL_ACTIVE_PARTNER_SUBSCRIPTION) || 'N/A';
  trackObject[MIXPANEL_CONTENT_OWNER] =
    mixpanelObject.getProperty(MIXPANEL_CONTENT_OWNER) || 'N/A';
};

// Cosumption Page Gamification Widget Impression Event
export const gamificationRibbonImpression = () => {
  if (typeof window !== 'undefined' && window.mixpanel) {
    const trackObject = basicInitializer(mixpanelObject);
    trackObject[MIXPANEL_PAGE_NAME] =
      mixpanelObject.getProperty(MIXPANEL_PAGE_NAME);
    trackObject[MIXPANEL_SOURCE] = mixpanelObject.getProperty(MIXPANEL_SOURCE);
    trackObject[MIXPANEL_PLATFORM_SECTION] = mixpanelObject.getProperty(
      MIXPANEL_PLATFORM_SECTION
    );
    mixpanelObject.queueMixpanelEvents(
      MIXPANEL_EVENTS_RIBBON_IMPRESSION,
      trackObject
    );
  }
};

export const screenViewEvent = (pageName = '') => {
  let trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_TAB_NAME] = mixpanelObject[MIXPANEL_TAB_NAME];
  trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
  trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';
  trackObject[MIXPANEL_UNIQUE_ID] = mixpanelObject[MIXPANEL_UNIQUE_ID];
  trackObject[MIXPANEL_LANDING_PAGE_NAME] =
    mixpanelObject[MIXPANEL_LANDING_PAGE_NAME];
  trackObject[MIXPANEL_PAGE_NAME] = mixpanelObject[MIXPANEL_PAGE_NAME];
  trackObject[MIXPANEL_AGE] = mixpanelObject[MIXPANEL_AGE] || 'N/A';
  aggregatorEventHelper(trackObject);
  mixpanelObject.queueMixpanelEvents(MIXPANEL_EVENTS_SCREEN_VIEW, trackObject);
  if (shouldOptOutOfPII()) {
    const objWithoutPII = optingOutOfPII();
    trackObject = { ...trackObject, ...objWithoutPII };
  }
  clevertapEventPush(MIXPANEL_EVENTS_SCREEN_VIEW, trackObject);
  trackEvent(MIXPANEL_EVENTS_SCREEN_VIEW, trackObject);
  //page view event must be sent for every page visit
  putFacebookEvent(
    META_EVENTS.PageView,
    new Date().getTime(),
    window.location.href
  );
};

export const recommendedRailImpression = () => {
  // if (typeof window !== "undefined" && window.mixpanel) {
  const trackObject = basicInitializer(mixpanelObject, false);
  trackObject[MIXPANEL_CAROUSAL_NAME] = mixpanelObject[MIXPANEL_CAROUSAL_NAME];
  trackObject[MIXPANEL_CAROUSAL_ID] = mixpanelObject[MIXPANEL_CAROUSAL_ID];
  trackObject[MIXPANEL_VERTICAL_INDEX] =
    mixpanelObject[MIXPANEL_TALAMOOS_VERTICAL_INDEX];
  trackObject[MIXPANEL_TALAMOOS_MODELNAME] =
    mixpanelObject[MIXPANEL_TALAMOOS_MODELNAME];
  mixpanelObject.trackEvent(
    MIXPANEL_EVENTS_RECOMMENDED_RAIL_IMPRESSION,
    trackObject
  );
  // }
};

// page rail impression
export const pageRailImpression = (isSearchLanding = false) => {
  const trackObject = basicInitializer(mixpanelObject, false);
  trackObject[MIXPANEL_LANDING_PAGE_NAME] =
    mixpanelObject[MIXPANEL_LANDING_PAGE_NAME] || 'N/A';
  trackObject[MIXPANEL_UNIQUE_ID] = mixpanelObject[MIXPANEL_UNIQUE_ID];
  trackObject[MIXPANEL_PAGE_NAME] = mixpanelObject[MIXPANEL_PAGE_NAME];
  trackObject[MIXPANEL_SOURCE] = mixpanelObject[MIXPANEL_SOURCE];
  trackObject[MIXPANEL_CAROUSAL_NAME] = mixpanelObject[MIXPANEL_CAROUSAL_NAME];
  trackObject[MIXPANEL_CAROUSAL_ID] = mixpanelObject[MIXPANEL_CAROUSAL_ID];
  trackObject[MIXPANEL_TAB_NAME] = mixpanelObject[MIXPANEL_TAB_NAME];
  trackObject[MIXPANEL_IS_RECOMMENDED] =
    mixpanelObject[MIXPANEL_IS_RECOMMENDED];
  trackObject[MIXPANEL_VERTICAL_INDEX] =
    mixpanelObject[MIXPANEL_TALAMOOS_VERTICAL_INDEX];
  trackObject[MIXPANEL_RAIL_CONTENT_LISTING] =
    mixpanelObject[MIXPANEL_RAIL_CONTENT_LISTING];
  trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
  trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';
  trackObject[MIXPANEL_MODEL_NAME] = mixpanelObject[MIXPANEL_MODEL_NAME];
  trackObject[MIXPANEL_MODEL_ORIGIN] = mixpanelObject[MIXPANEL_MODEL_ORIGIN];
  aggregatorEventHelper(trackObject);
  trackObject[MIXPANEL_HORIZONTAL_INDEX] =
    mixpanelObject[MIXPANEL_HORIZONTAL_INDEX];
  trackObject[MIXPANEL_USER_TYPE] = getLocalStorage(USER_TYPE);
  let eventName = '';
  if (isSearchLanding) {
    trackObject[MIXPANEL_PAGE_NAME] = MIXPANEL_SEARCH_LANDING;
    trackObject[MIXPANEL_SEARCH_QUERY] = MIXPANEL_NO_KEYWORD;
    trackObject[MIXPANEL_QUERY_ID] = MIXPANEL_NO_KEYWORD;
    trackObject[MIXPANEL_SEARCH_TYPE] = MIXPANEL_SEARCH_TYPE;
    trackObject[MIXPANEL_NAVIGATION_PROPERTY] = MIXPANEL_SEARCH_LANDING;
    trackObject[MIXPANEL_RAIL_CONTENT_LISTING_ID] =
      mixpanelObject[MIXPANEL_RAIL_CONTENT_LISTING_ID];
    trackObject[MIXPANEL_CAROUSAL_NAME] =
      mixpanelObject[MIXPANEL_CAROUSAL_NAME];
    trackObject[MIXPANEL_CONTENT_COUNT] =
      mixpanelObject[MIXPANEL_CONTENT_COUNT];
    trackObject[MIXPANEL_CAROUSAL_SLOT_ID] =
      mixpanelObject[MIXPANEL_CAROUSAL_SLOT_ID];
    trackObject[MIXPANEL_MODEL_ID] = MIXPANEL_NO_MODEL_SERVED;

    eventName = MIXPANEL_EVENTS_SEARCH_RAIL_IMPRESSION;
    mixpanelObject.trackEvent(eventName, trackObject);
  } else {
    eventName = MIXPANEL_EVENTS_PAGE_RAIL_IMPRESSION;
    mixpanelObject.trackEvent(eventName, trackObject);
  }
};

// Dropdown
export const selectDropdownContent = () => {
  // if (typeof window !== "undefined" && window.mixpanel) {
  const trackObject = basicInitializer(mixpanelObject, true);
  trackObject[MIXPANEL_SERIES] = mixpanelObject[MIXPANEL_SERIES];
  trackObject[MIXPANEL_ELEMENT] = mixpanelObject[MIXPANEL_ELEMENT];
  trackObject[MIXPANEL_CONTENT_ID] = mixpanelObject[MIXPANEL_CONTENT_ID];
  trackObject[MIXPANEL_CONTENT_NAME] = mixpanelObject[MIXPANEL_CONTENT_NAME];
  trackObject[MIXPANEL_LANDING_PAGE_NAME] =
    mixpanelObject[MIXPANEL_LANDING_PAGE_NAME];
  trackObject[MIXPANEL_ZEE5_COUNTRY] = mixpanelObject[MIXPANEL_ZEE5_COUNTRY];
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_EPISODE_LIST_CHOSEN,
    trackObject
  );
  mixpanelObject.trackEvent(MIXPANEL_EVENTS_PAGE_RAIL_IMPRESSION, trackObject);
  mixpanelObject[MIXPANEL_SERIES] = 'N/A';
  // }
};

// Thumbnail Click event method
export const ThumbnailClickEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  contentPropertiesCompressor(mixpanelObject, trackObject, true, true);
  trackObject[MIXPANEL_TAB_NAME] = mixpanelObject[MIXPANEL_TAB_NAME];
  trackObject[MIXPANEL_IMAGE_URL] = mixpanelObject[MIXPANEL_IMAGE_URL];
  trackObject[MIXPANEL_IS_TALAMOOS] = mixpanelObject[MIXPANEL_IS_TALAMOOS];
  trackObject[MIXPANEL_TALAMOOS_MODELNAME] =
    mixpanelObject[MIXPANEL_TALAMOOS_MODELNAME];
  trackObject[MIXPANEL_TALAMOOS_ORIGIN] =
    mixpanelObject[MIXPANEL_TALAMOOS_ORIGIN];
  trackObject[MIXPANEL_TALAMOOS_CLICKID] =
    mixpanelObject[MIXPANEL_TALAMOOS_CLICKID];
  trackObject[MIXPANEL_PREVIEW_STATUS] =
    mixpanelObject[MIXPANEL_PREVIEW_STATUS];
  trackObject[MIXPANEL_EXTERNAL_LINK] = mixpanelObject[MIXPANEL_EXTERNAL_LINK];
  trackObject[MIXPANEL_IS_EDUAURAA] = mixpanelObject[MIXPANEL_IS_EDUAURAA];
  trackObject[MIXPANEL_IS_RECOMMENDED] =
    mixpanelObject[MIXPANEL_IS_RECOMMENDED];
  trackObject[MIXPANEL_MODEL_NAME] = mixpanelObject[MIXPANEL_MODEL_NAME];
  trackObject[MIXPANEL_MODEL_ORIGIN] = mixpanelObject[MIXPANEL_MODEL_ORIGIN];
  trackObject[MIXPANEL_IS_LIVE] = mixpanelObject[MIXPANEL_IS_LIVE];
  trackObject[MIXPANEL_EPISODE_NO] = mixpanelObject[MIXPANEL_EPISODE_NO];

  // for tvod
  trackObject[MIXPANEL_IS_RENTAL] = mixpanelObject[MIXPANEL_IS_RENTAL];
  trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
  trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';
  trackObject[MIXPANEL_CAROUSAL_NAME] = mixpanelObject[MIXPANEL_CAROUSAL_NAME];
  trackObject[MIXPANEL_VERTICAL_INDEX] =
    mixpanelObject[MIXPANEL_VERTICAL_INDEX];
  trackObject[MIXPANEL_HORIZONTAL_INDEX] =
    mixpanelObject[MIXPANEL_HORIZONTAL_INDEX];
  trackObject[MIXPANEL_SOURCE] = mixpanelObject[MIXPANEL_SOURCE];
  trackObject[MIXPANEL_PAGE_NAME] = mixpanelObject[MIXPANEL_PAGE_NAME];
  trackObject[MIXPANEL_CONTENT_NAME] = mixpanelObject[MIXPANEL_CONTENT_NAME];
  trackObject[MIXPANEL_AVOD_OR_SVOD_CONTENT] =
    mixpanelObject[MIXPANEL_AVOD_OR_SVOD_CONTENT];
  trackObject[MIXPANEL_USER_TYPE] = getLocalStorage(USER_TYPE);
  if (mixpanelObject[MIXPANEL_CONTENT_TYPE] === 'tvod') {
    trackObject[MIXPANEL_RENTAL_EXPIRY_DATE] =
      mixpanelObject[MIXPANEL_RENTAL_EXPIRY_DATE];
    trackObject[MIXPANEL_COST] = mixpanelObject[MIXPANEL_COST];
    trackObject[MIXPANEL_RENTAL_RELEASE_DATE] =
      mixpanelObject[MIXPANEL_RENTAL_RELEASE_DATE];
    trackObject[MIXPANEL_RENTAL_PURCHASE_DATE] =
      mixpanelObject[MIXPANEL_RENTAL_PURCHASE_DATE];
    trackObject[MIXPANEL_RENTAL_PURCHASE_EXPIRY_DATE] =
      mixpanelObject[MIXPANEL_RENTAL_PURCHASE_EXPIRY_DATE];
    trackObject[MIXPANEL_ACTUAL_COST] = mixpanelObject[MIXPANEL_ACTUAL_COST];
    trackObject[MIXPANEL_CONTENT_SPECIFICATION] =
      mixpanelObject[MIXPANEL_CONTENT_SPECIFICATION];
  }

  aggregatorEventHelper(trackObject);
  mixpanelObject.trackEvent(MIXPANEL_EVENTS_THUMBNAIL_CLICK, trackObject);
  clevertapEventPush(MIXPANEL_EVENTS_THUMBNAIL_CLICK, trackObject);
  // }
};
// subscription plan viewed event method
export const subscriptionPlanViewedEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_POP_UP_NAME] =
    mixpanelObject.getProperty(MIXPANEL_POP_UP_NAME);
  trackObject[MIXPANEL_POP_UP_GROUP] = mixpanelObject.getProperty(
    MIXPANEL_POP_UP_GROUP
  );
  trackObject[MIXPANEL_PAGE_NAME] =
    mixpanelObject.getProperty(MIXPANEL_PAGE_NAME);

  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_SUBSCRIPTION_PLAN_VIEWED,
    trackObject
  );
  trackEvent(MIXPANEL_EVENTS_SUBSCRIPTION_PLAN_VIEWED, trackObject);
};

// Dropdown TODO:: verify with above selectDropdownContent
// export const selectDropdownContent = () => {
//   if (typeof window !== 'undefined' && window.mixpanel) {
//     const trackObject = basicInitializer(mixpanelObject, true);
//     trackObject[MIXPANEL_SERIES] =
//       mixpanelObject[MIXPANEL_SERIES];
//     trackObject[MIXPANEL_LANDING_PAGE_NAME] =
//       mixpanelObject[MIXPANEL_LANDING_PAGE_NAME];
//     trackObject[MIXPANEL_ELEMENT] =
//       mixpanelObject[MIXPANEL_ELEMENT];
//     mixpanelObject.trackEvent(
//       MIXPANEL_EVENTS_EPISODE_LIST_CHOSEN,
//       trackObject
//     );
//   }
// };
export const likeDislikeCtaEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_ELEMENT] = mixpanelObject.getProperty(MIXPANEL_ELEMENT);
  trackObject[MIXPANEL_BUTTON_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_BUTTON_TYPE);
  trackObject[MIXPANEL_PAGE_NAME] =
    mixpanelObject.getProperty(MIXPANEL_PAGE_NAME);
  trackObject[MIXPANEL_CONTENT_NAME] = mixpanelObject.getProperty(
    MIXPANEL_CONTENT_NAME
  );
  trackObject[MIXPANEL_CONTENT_ID] =
    mixpanelObject.getProperty(MIXPANEL_CONTENT_ID);
  trackObject[MIXPANEL_CONTENT_SPECIFICATION] = mixpanelObject.getProperty(
    MIXPANEL_CONTENT_SPECIFICATION
  );
  trackObject[MIXPANEL_CONTENT_TYPE] = mixpanelObject.getProperty(
    MIXPANEL_CONTENT_TYPE
  );
  trackObject[MIXPANEL_TOP_CATEGORY] = mixpanelObject.getProperty(
    MIXPANEL_TOP_CATEGORY
  );
  trackObject[MIXPANEL_SERIES] = mixpanelObject.getProperty(MIXPANEL_SERIES);
  trackObject[MIXPANEL_GENRE] = mixpanelObject.getProperty(MIXPANEL_GENRE);
  trackObject[MIXPANEL_LIKE_DISLIKE_TOGGLE] = mixpanelObject.getProperty(
    MIXPANEL_LIKE_DISLIKE_TOGGLE
  );

  mixpanelObject.trackEvent(MIXPANEL_EVENTS_CTAS, trackObject);
};

// Thumbnail Click event method
export const thumbnailClickEvent = (isSearchLanding = false) => {
  const trackObject = basicInitializer(mixpanelObject);
  contentPropertiesCompressor(mixpanelObject, trackObject, true, true);
  (trackObject[MIXPANEL_PAGE_NAME] =
    mixpanelObject.getProperty(MIXPANEL_PAGE_NAME)),
    (trackObject[MIXPANEL_TAB_NAME] =
      mixpanelObject.getProperty(MIXPANEL_TAB_NAME));
  trackObject[MIXPANEL_IMAGE_URL] =
    mixpanelObject.getProperty(MIXPANEL_IMAGE_URL);
  trackObject[MIXPANEL_IS_TALAMOOS] =
    mixpanelObject.getProperty(MIXPANEL_IS_TALAMOOS);
  trackObject[MIXPANEL_TALAMOOS_MODELNAME] = mixpanelObject.getProperty(
    MIXPANEL_TALAMOOS_MODELNAME
  );
  if (isSearchLanding) {
    trackObject[MIXPANEL_SEARCH_QUERY] = MIXPANEL_NO_KEYWORD;
    trackObject[MIXPANEL_QUERY_ID] = MIXPANEL_NO_KEYWORD;
    trackObject[MIXPANEL_NAVIGATION_PROPERTY] = MIXPANEL_SEARCH_LANDING;
    trackObject[MIXPANEL_SEARCH_TYPE] = MIXPANEL_SEARCH_LANDING;
    trackObject[MIXPANEL_SERIES] = mixpanelObject[MIXPANEL_SERIES];
    trackObject[MIXPANEL_CAROUSAL_SLOT_ID] =
      mixpanelObject[MIXPANEL_CAROUSAL_SLOT_ID];
    trackObject[MIXPANEL_CAROUSAL_ID] = mixpanelObject[MIXPANEL_CAROUSAL_ID];
    trackObject[MIXPANEL_RAIL_CONTENT_LISTING] =
      mixpanelObject[MIXPANEL_RAIL_CONTENT_LISTING];
  }
  trackObject[MIXPANEL_PAGE_NAME] = isSearchLanding
    ? MIXPANEL_SEARCH_LANDING
    : mixpanelObject.getProperty(MIXPANEL_PAGE_NAME);
  trackObject[MIXPANEL_TAB_NAME] =
    mixpanelObject.getProperty(MIXPANEL_TAB_NAME);
  trackObject[MIXPANEL_IMAGE_URL] =
    mixpanelObject.getProperty(MIXPANEL_IMAGE_URL);
  trackObject[MIXPANEL_TALAMOOS_ORIGIN] = mixpanelObject.getProperty(
    MIXPANEL_TALAMOOS_ORIGIN
  );
  trackObject[MIXPANEL_TALAMOOS_CLICKID] = mixpanelObject.getProperty(
    MIXPANEL_TALAMOOS_CLICKID
  );
  trackObject[MIXPANEL_PREVIEW_STATUS] = mixpanelObject.getProperty(
    MIXPANEL_PREVIEW_STATUS
  );
  trackObject[MIXPANEL_EXTERNAL_LINK] = mixpanelObject.getProperty(
    MIXPANEL_EXTERNAL_LINK
  );
  trackObject[MIXPANEL_IS_EDUAURAA] =
    mixpanelObject.getProperty(MIXPANEL_IS_EDUAURAA);
  trackObject[MIXPANEL_IS_RECOMMENDED] = mixpanelObject.getProperty(
    MIXPANEL_IS_RECOMMENDED
  );
  trackObject[MIXPANEL_MODEL_NAME] =
    mixpanelObject.getProperty(MIXPANEL_MODEL_NAME);
  trackObject[MIXPANEL_MODEL_ORIGIN] = mixpanelObject.getProperty(
    MIXPANEL_MODEL_ORIGIN
  );
  trackObject[MIXPANEL_IS_LIVE] = mixpanelObject.getProperty(MIXPANEL_IS_LIVE);
  trackObject[MIXPANEL_NAVIGATION_PROPERTY] = mixpanelObject.getProperty(
    MIXPANEL_NAVIGATION_PROPERTY
  );
  trackObject[MIXPANEL_IS_RENTAL] =
    mixpanelObject.getProperty(MIXPANEL_IS_RENTAL);
  trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
  trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';
  trackObject[MIXPANEL_CAROUSAL_NAME] = mixpanelObject.getProperty(
    MIXPANEL_CAROUSAL_NAME
  );
  trackObject[MIXPANEL_VERTICAL_INDEX] = mixpanelObject.getProperty(
    MIXPANEL_VERTICAL_INDEX
  );
  trackObject[MIXPANEL_HORIZONTAL_INDEX] = mixpanelObject.getProperty(
    MIXPANEL_HORIZONTAL_INDEX
  );
  trackObject[MIXPANEL_SOURCE] = mixpanelObject.getProperty(MIXPANEL_SOURCE);
  trackObject[MIXPANEL_CONTENT_NAME] = mixpanelObject.getProperty(
    MIXPANEL_CONTENT_NAME
  );
  trackObject[MIXPANEL_AVOD_OR_SVOD_CONTENT] = mixpanelObject.getProperty(
    MIXPANEL_AVOD_OR_SVOD_CONTENT
  );
  trackObject[MIXPANEL_USER_TYPE] = getLocalStorage(USER_TYPE);
  if (mixpanelObject[MIXPANEL_CONTENT_TYPE] === mixpanelObject[MIXPANEL_TVOD]) {
    trackObject[MIXPANEL_RENTAL_EXPIRY_DATE] = mixpanelObject.getProperty(
      MIXPANEL_RENTAL_EXPIRY_DATE
    );
    trackObject[MIXPANEL_COST] = mixpanelObject.getProperty(MIXPANEL_COST);
    trackObject[MIXPANEL_RENTAL_RELEASE_DATE] = mixpanelObject.getProperty(
      MIXPANEL_RENTAL_RELEASE_DATE
    );
    trackObject[MIXPANEL_RENTAL_PURCHASE_DATE] = mixpanelObject.getProperty(
      MIXPANEL_RENTAL_PURCHASE_DATE
    );
    trackObject[MIXPANEL_RENTAL_PURCHASE_EXPIRY_DATE] =
      mixpanelObject.getProperty(MIXPANEL_RENTAL_PURCHASE_EXPIRY_DATE);
    trackObject[MIXPANEL_ACTUAL_COST] =
      mixpanelObject.getProperty(MIXPANEL_ACTUAL_COST);
    trackObject[MIXPANEL_CONTENT_SPECIFICATION] = mixpanelObject.getProperty(
      MIXPANEL_CONTENT_SPECIFICATION
    );
  }

  aggregatorEventHelper(trackObject);
  const eventName = isSearchLanding
    ? MIXPANEL_EVENTS_SEARCH_THUMBNAIL_CLICK
    : MIXPANEL_EVENTS_THUMBNAIL_CLICK;
  mixpanelObject.queueMixpanelEvents(eventName, trackObject);
  clevertapEventPush(eventName, trackObject);
};

// search result clicked event method
export const searchResultClickedEvent = () => {
  const trackObject = basicInitializer(mixpanelObject);
  contentPropertiesCompressor(mixpanelObject, trackObject, false, false);

  trackObject[MIXPANEL_QUERY_ID] = mixpanelObject.getProperty(
    MIXPANEL_QUERY_ID || 'N/A'
  );
  trackObject[MIXPANEL_TAB_NAME] =
    mixpanelObject.getProperty(MIXPANEL_TAB_NAME);
  trackObject[MIXPANEL_SEARCH_TYPE] =
    mixpanelObject.getProperty(MIXPANEL_SEARCH_TYPE);
  trackObject[MIXPANEL_SEARCH_QUERY] = mixpanelObject.getProperty(
    MIXPANEL_SEARCH_QUERY
  );
  trackObject[MIXPANEL_NULL_SEARCH] =
    mixpanelObject.getProperty(MIXPANEL_NULL_SEARCH);
  trackObject[MIXPANEL_CAROUSAL_NAME] = mixpanelObject.getProperty(
    MIXPANEL_CAROUSAL_NAME
  );
  trackObject[MIXPANEL_CONTENT_TYPE] = mixpanelObject.getProperty(
    MIXPANEL_CONTENT_TYPE
  );
  trackObject[MIXPANEL_EXPERIMENT_NAME] = getExperimentName() || 'N/A';
  trackObject[MIXPANEL_VARIANT_NAME] = getExperimentVariant() || 'N/A';

  aggregatorEventHelper(trackObject);
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_SEARCH_RESULT_CLICKED,
    trackObject
  );
  clevertapEventPush(MIXPANEL_EVENTS_SEARCH_RESULT_CLICKED, trackObject);
};
// view more selected event method
export const viewMoreSelectedEvent = () => {
  const trackObject = basicInitializer(mixpanelObject, true);
  trackObject[MIXPANEL_VERTICAL_INDEX] = mixpanelObject.getProperty(
    MIXPANEL_VERTICAL_INDEX
  );
  trackObject[MIXPANEL_HORIZONTAL_INDEX] = mixpanelObject.getProperty(
    MIXPANEL_HORIZONTAL_INDEX
  );
  trackObject[MIXPANEL_CAROUSAL_ID] =
    mixpanelObject.getProperty(MIXPANEL_CAROUSAL_ID);
  trackObject[MIXPANEL_CAROUSAL_NAME] = mixpanelObject.getProperty(
    MIXPANEL_CAROUSAL_NAME
  );
  trackObject[MIXPANEL_EXTERNAL_LINK] = mixpanelObject.getProperty(
    MIXPANEL_EXTERNAL_LINK
  );
  trackObject[MIXPANEL_IMAGE_URL] =
    mixpanelObject.getProperty(MIXPANEL_IMAGE_URL);
  trackObject[MIXPANEL_IS_TALAMOOS] =
    mixpanelObject.getProperty(MIXPANEL_IS_TALAMOOS);
  trackObject[MIXPANEL_TALAMOOS_MODELNAME] = mixpanelObject.getProperty(
    mixpanelObject.TALAMOOS_MODELNAME
  );
  if (trackObject[MIXPANEL_PAGE_NAME] === H1_TAG_TITLE.ILT20) {
    trackObject[MIXPANEL_TAB_NAME] = H1_TAG_TITLE.ILT20;
  }
  aggregatorEventHelper(trackObject);
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_VIEW_MORE_SELECTED,
    trackObject
  );
};

export const contentBannerClick = (ctaFlag = false) => {
  const trackObject = basicInitializer(mixpanelObject, false);
  trackObject[MIXPANEL_VERTICAL_INDEX] = mixpanelObject.getProperty(
    MIXPANEL_VERTICAL_INDEX
  );
  contentPropertiesCompressor(mixpanelObject, trackObject, false, false);
  delete trackObject[MIXPANEL_CONTENT_BILLING_TYPE];
  delete trackObject[MIXPANEL_PUBLISHING_DATE];
  delete trackObject[MIXPANEL_SERIES];
  delete trackObject[MIXPANEL_EPISODE_NO];
  delete trackObject[MIXPANEL_EXTERNAL_LINK];
  trackObject[MIXPANEL_TAB_NAME] =
    mixpanelObject.getProperty(MIXPANEL_TAB_NAME);
  trackObject[MIXPANEL_CAROUSAL_NAME] = mixpanelObject.getProperty(
    MIXPANEL_CAROUSAL_NAME
  );
  trackObject[MIXPANEL_CAROUSAL_ID] =
    mixpanelObject.getProperty(MIXPANEL_CAROUSAL_ID);
  trackObject[MIXPANEL_COST] = mixpanelObject.getProperty(MIXPANEL_COST);
  trackObject[MIXPANEL_ACTUAL_COST] =
    mixpanelObject.getProperty(MIXPANEL_ACTUAL_COST);
  trackObject[MIXPANEL_IS_RENTAL] =
    mixpanelObject.getProperty(MIXPANEL_IS_RENTAL);
  trackObject[MIXPANEL_RENTAL_RELEASE_DATE] = mixpanelObject.getProperty(
    MIXPANEL_RENTAL_RELEASE_DATE
  );
  trackObject[MIXPANEL_RENTAL_PURCHASE_DATE] = mixpanelObject.getProperty(
    MIXPANEL_RENTAL_PURCHASE_DATE
  );
  trackObject[MIXPANEL_RENTAL_PURCHASE_EXPIRY_DATE] =
    mixpanelObject.getProperty(MIXPANEL_RENTAL_PURCHASE_EXPIRY_DATE);
  if (ctaFlag) {
    trackObject[MIXPANEL_ELEMENT] =
      mixpanelObject.getProperty(MIXPANEL_ELEMENT);
    trackObject[MIXPANEL_BUTTON_TYPE] =
      mixpanelObject.getProperty(MIXPANEL_BUTTON_TYPE);
  }
  const eventName = ctaFlag
    ? MIXPANEL_EVENTS_BELLY_UNIT_CTA
    : MIXPANEL_EVENTS_CONTENT_BANNER_CLICK;
  mixpanelObject.queueMixpanelEvents(eventName, trackObject);
};

export const deepLinkDataEvent = (
  contentID: string,
  partnerName: string,
  path = '' as string,
  isRedirection = false as boolean
) => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_ISB2B] = true;
  trackObject[MIXPANEL_CONTENT_ID] = contentID;
  trackObject[MIXPANEL_DEEPLINK_PARTNER_NAME] = partnerName;
  if (isRedirection) {
    trackObject[MIXPANEL_DEEPLINK_REDIRECTION_PATH] = path;
  }
  const event = isRedirection
    ? MIXPANEL_EVENTS_DEEP_LINK_REDIRECTION
    : MIXPANEL_EVENTS_DEEP_LINK_DATA;
  mixpanelObject.queueMixpanelEvents(event, trackObject);
};

export const partnerSettingsDataEvent = (
  partnerName: string,
  partnerId: number
) => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_PS_PARTNER_NAME] = partnerName;
  trackObject[MIXPANEL_PARTNER_ID] = partnerId;
  trackObject[MIXPANEL_ISB2B] = true;
  mixpanelObject.queueMixpanelEvents(
    MIXPANEL_EVENTS_PARTNER_SETTING_DATA,
    trackObject
  );
};
